{
    "recruiting": "Rekrutacja",
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Strona nie znaleziona ⚠️",
    "404_description": "Nie możemy znaleźć strony, której szukasz.",
    "404_home": "Powrót do strony głównej",
    "401_title": "Brak autoryzacji! 🔐",
    "401_description": "Nie masz uprawnień do wyświetlenia tej strony. Wróć do strony głównej!.",
    "401_home": "Powrót do strony głównej",
    "changes_saved": "Zmiany zapisane",
    "coming_soon": "Wkrótce dostępne",
    "retry": "Spróbuj ponownie",
    " ": " ",
    "select_date_and_time": "Wybierz datę i godzinę",
    "select_date": "Wybierz datę",
    "chat": "Czat",
    "menu": "Menu",
    "games": "Sesje",
    "tours": "Tury",
    "library": "Biblioteka",
    "library-video": "Wideo",
    "library-scorm": "Kursy",
    "library-documents": "Dokumenty",
    "knowledge-base": "Baza wiedzy",
    "courses": "Kursy",
    "courses-page": {
        "title": "Kursy",
        "create": "Utwórz kurs",
        "edit": "Edytuj kurs",
        "empty": "Brak kursów",
        "fields": {
            "title": "Tytuł",
            "description": "Opis",
            "documents-count": "Dokumenty"
        },
        "headers": {
            "title": "Tytuł",
            "description": "Opis",
            "documents": "Dokumenty",
            "actions": "Akcje"
        },
        "dialog": {
            "title-label": "Tytuł",
            "description-label": "Opis",
            "documents-label": "Dokumenty",
            "documents-placeholder": "Wybierz dokumenty z bazy wiedzy",
            "save": "Zapisz",
            "cancel": "Anuluj"
        },
        "messages": {
            "created": "Kurs utworzony",
            "updated": "Kurs zaktualizowany",
            "deleted": "Kurs usunięty",
            "error": "Coś poszło nie tak"
        },
        "confirm-delete": "Usunąć ten kurs? Tej operacji nie można cofnąć."
    },
    "ai-study-chat": "Czat AI do nauki",
    "ai-study-chat-page": {
        "title": "Czat AI do nauki",
        "new-conversation": "Nowa rozmowa",
        "empty-sidebar": "Brak rozmów",
        "empty-thread": "Wybierz kurs lub scenariusz, aby rozpocząć naukę",
        "untitled": "Nowy czat",
        "input-placeholder": "Wpisz swoje pytanie…",
        "send": "Wyślij",
        "typing": "Asystent pisze…",
        "sources": "Źródła ({count})",
        "sources-label": "Źródła",
        "score": "trafność",
        "retry": "Ponów",
        "copy": "Kopiuj",
        "copied": "Skopiowano",
        "failed": "Nie udało się wysłać",
        "search-placeholder": "Szukaj rozmów",
        "search-empty": "Nic nie znaleziono",
        "empty": {
            "heading": "Gotowy, aby pomóc Ci się uczyć",
            "subtitle": "Zadaj dowolne pytanie dotyczące materiałów kursu — znajdę odpowiedź w bazie wiedzy i pokażę źródła."
        },
        "groups": {
            "today": "Dziś",
            "yesterday": "Wczoraj",
            "earlier": "Wcześniej"
        },
        "composer": {
            "context": "Kontekst:",
            "hint": "Odpowiedzi są generowane przez AI na podstawie Twoich materiałów · Enter, aby wysłać, Shift+Enter, aby przejść do nowej linii"
        },
        "suggestions-fallback": [
            {
                "title": "Podsumuj materiały",
                "subtitle": "Kluczowe punkty"
            },
            {
                "title": "Stwórz plan nauki",
                "subtitle": "Od czego zacząć"
            },
            {
                "title": "Sprawdź moją wiedzę",
                "subtitle": "Szybki test"
            },
            {
                "title": "Wyjaśnij prosto",
                "subtitle": "Bez żargonu"
            }
        ],
        "suggestions-fallback-debrief": [
            { "title": "Omów tę sesję", "subtitle": "Najważniejsze wnioski" },
            { "title": "Co zrobiłem dobrze?", "subtitle": "Moje mocne strony" },
            { "title": "Gdzie popełniłem błąd i dlaczego?", "subtitle": "Punkty wzrostu" },
            { "title": "Co poprawić w następnej sesji?", "subtitle": "Konkretne kroki" }
        ],
        "suggestions-fallback-progress": [
            { "title": "Jak zmieniają się moje wyniki?", "subtitle": "Na przestrzeni sesji" },
            { "title": "Moje mocne i słabe umiejętności", "subtitle": "Z wyników sesji" },
            { "title": "Na czym powinienem się skupić?", "subtitle": "Priorytet treningowy" },
            { "title": "Porównaj moją pierwszą i ostatnią sesję", "subtitle": "Co się poprawiło" }
        ],
        "quota": {
            "remaining": "Pozostało {count} wiadomości",
            "exhausted": "Wyczerpałeś limit wiadomości AI.",
            "unavailable": "Czat AI nie jest dostępny w Twoim planie."
        },
        "new-dialog": {
            "title": "Nowa rozmowa",
            "subtitle": "Wybierz źródło, z którego AI będzie odpowiadać",
            "search": "Szukaj…",
            "search-empty": "Nic nie znaleziono",
            "source-type": "Źródło",
            "source-course": "Kurs",
            "source-scenario": "Scenariusz",
            "source-competency": "Kompetencja",
            "pick-course": "Wybierz kurs",
            "pick-scenario": "Wybierz scenariusz",
            "pick-competency": "Wybierz kompetencję",
            "pick-target": "Wszystkie sesje lub konkretna sesja",
            "all-games": "Wszystkie sesje — moje postępy",
            "all-games-sub": "Trendy wyników dla tej kompetencji",
            "back": "Wstecz",
            "no-games": "Brak ukończonych sesji",
            "empty-competencies": "Na razie brak ukończonych sesji",
            "empty-competencies-hint": "Ukończ sesję ze scenariusza z kompetencją — tutaj pojawi się analiza AI",
            "empty-courses": "Na razie brak dostępnych kursów",
            "empty-scenarios": "Na razie brak dostępnych scenariuszy",
            "tag-game": "Sesja",
            "start": "Rozpocznij",
            "cancel": "Anuluj"
        },
        "stage": {
            "searching": "Przeszukuję Twoje materiały…",
            "reading": "Czytam źródła…",
            "writing": "Piszę odpowiedź…",
            "writing_sources": "Analizuję {count} fragmentów…",
            "summarizing_short": "Porządkuję wcześniejszy kontekst",
            "searching_short": "Przeszukuję materiały",
            "reading_short": "Czytam źródła",
            "writing_short": "Piszę odpowiedź",
            "writing_sources_short": "Analizuję {count} fragmentów"
        },
        "errors": {
            "send": "Nie udało się wysłać wiadomości. Spróbuj ponownie.",
            "quota": "Osiągnięto limit wiadomości.",
            "rate_limit": "Zbyt wiele żądań. Odczekaj minutę i spróbuj ponownie.",
            "provider_unsupported": "Czat bazy wiedzy jest niedostępny dla obecnego dostawcy AI Twojej organizacji.",
            "generic": "Coś poszło nie tak."
        }
    },
    "scenarios": "Scenariusze",
    "competencies": "Kompetencje",
    "competencies-list": "Lista",
    "skills": "Umiejętności",
    "home": "Strona główna",
    "home_player": "Uczestnik",
    "player": "Uczestnik",
    "home_expert": "Ekspert",
    "reports-analytics-tours": "Tury",
    "reports": "Raporty",
    "skill_reports": {
        "skill_development_report": "Raport rozwoju umiejętności",
        "generate": "Generuj",
        "generate_description": "Wygeneruj kompleksowy raport rozwoju umiejętności dla wybranego okresu",
        "manager_description": "Generuj raporty rozwoju umiejętności dla pracowników swojej organizacji",
        "date": "Data",
        "competence": "Kompetencja",
        "period": "Okres",
        "status_label": "Status",
        "actions": "Akcje",
        "employee": "Pracownik",
        "view": "Wyświetl raport",
        "download_pdf": "Pobierz PDF",
        "no_reports": "Nie wygenerowano jeszcze żadnych raportów",
        "data_not_available": "Dane raportu nie są jeszcze dostępne",
        "generation_failed": "Generowanie raportu nie powiodło się",
        "retry": "Ponów",
        "rate_limit_exceeded": "Osiągnięto limit generowania raportów. Spróbuj ponownie później.",
        "too_many_pending": "Masz zbyt wiele raportów w toku. Poczekaj na ich zakończenie.",
        "no_games_for_report": "Nie znaleziono ukończonych sesji dla wybranego okresu i kompetencji. Raport nie może zostać wygenerowany.",
        "report_already_exists": "Raport z tymi parametrami już istnieje. Sprawdź listę poniżej.",
        "period_too_long": "Okres raportu nie może przekraczać jednego roku.",
        "invalid_parameters": "Sprawdź kompetencję i okres",
        "filter_by_employee": "Filtruj według pracownika...",
        "batch": {
            "mode_single": "Pojedynczy raport",
            "mode_batch": "Pakiet",
            "load_employees": "Pokaż pracowników",
            "sessions": "Sesje",
            "no_candidates": "Brak pracowników z zakończonymi sesjami dla wybranej kompetencji i okresu",
            "generate_selected": "Wygeneruj ({count})",
            "selected_limit": "Jednorazowo można wybrać maksymalnie {max} pracowników",
            "progress": "Gotowe: {ready} z {total}",
            "failed_count": "Błędy: {count}",
            "status_unknown": "Status nieznany",
            "status_unknown_hint": "Nie znaleziono raportu na liście — sprawdź tabelę raportów poniżej",
            "reused": "Ponownie użyte raporty: {count} — powstały w ciągu ostatnich {hours} godz. i nie były tworzone od nowa",
            "reused_badge": "Ponownie użyty",
            "reused_on": "Utworzony {date}",
            "download_all": "Pobierz wszystko",
            "toggle_details": "Pokaż zawartość pakietu",
            "dismiss_confirm": "Ten pakiet jest jeszcze generowany. Usunąć go z ekranu? Postęp i przycisk „Pobierz wszystko” zostaną utracone, raporty pozostaną na liście poniżej.",
            "archive_unavailable": "Nie udało się utworzyć archiwum: część raportów nie jest jeszcze gotowa lub nie jest już dostępna",
            "archive_failed": "Nie udało się pobrać archiwum",
            "archive_building": "Tworzenie archiwum…",
            "archive_build_failed": "Nie udało się utworzyć archiwum. Spróbuj ponownie.",
            "candidates_failed": "Nie udało się wczytać listy pracowników",
            "stale_selection": "Część wybranych pracowników nie jest już dostępna. Lista została odświeżona — wybierz ponownie."
        },
        "quota": {
            "remaining_hour": "Limit raportów: {limit} na godzinę. Możesz teraz zamówić jeszcze {remaining}. Wybierz mniej pracowników lub spróbuj ponownie o {time}.",
            "remaining_day": "Limit raportów: {limit} na dobę. Możesz teraz zamówić jeszcze {remaining}. Wybierz mniej pracowników lub spróbuj ponownie o {time}.",
            "exhausted_hour": "Limit raportów ({limit} na godzinę) został osiągnięty. Zostanie zresetowany o {time}.",
            "exhausted_day": "Limit raportów ({limit} na dobę) został osiągnięty. Zostanie zresetowany o {time}.",
            "too_large_hour": "Limit raportów: {limit} na godzinę. Wybierz mniej pracowników.",
            "too_large_day": "Limit raportów: {limit} na dobę. Wybierz mniej pracowników."
        },
        "status": {
            "pending": "Oczekuje",
            "collecting_data": "Zbieranie danych...",
            "analyzing": "Analiza AI...",
            "generating_pdf": "Generowanie PDF...",
            "ready": "Gotowy",
            "failed": "Błąd"
        },
        "report": {
            "kicker": "Raport rozwoju kompetencji",
            "position": "Stanowisko",
            "department": "Dział",
            "period": "Okres",
            "games_count": "Przeprowadzone sesje",
            "not_specified_f": "Nie podano",
            "not_specified_n": "Nie podano",
            "fig": {
                "your_average": "Twój średni wynik",
                "company_average": "Średnia firmy",
                "participants": "Uczestników w okresie",
                "skills_count": "Ocenione umiejętności"
            },
            "sec": {
                "profile": "Profil kompetencji",
                "trend": "Przebieg według sesji",
                "strengths": "Na czym się oprzeć",
                "priorities": "Trzy priorytety rozwoju",
                "skills": "Analiza według umiejętności",
                "plan": "Plan na trzy miesiące"
            },
            "legend": {
                "you": "Twój wynik",
                "company": "Średnia firmy"
            },
            "dotplot_caption": "Odchylenie od średniej — od największej przewagi do największej straty",
            "trend_disclaimer": "Wyniki poszczególnych sesji nie są bezpośrednio porównywalne: trudność przypadków różni się z sesji na sesję. Spadek sam w sobie nie oznacza pogorszenia umiejętności — wykres jest obserwacją, a nie werdyktem.",
            "no_comparison": "Porównanie ze średnią firmy jest niedostępne: w tym okresie sesje z tej kompetencji przeprowadziło mniej niż trzy osoby. Raport opiera się na wynikach bezwzględnych.",
            "skill": {
                "works": "Co wychodzi",
                "blocks": "Co przeszkadza",
                "actions": "Co robić",
                "out_of_ten": "z 10",
                "company_short": "firma"
            },
            "level": {
                "outstanding": "Wynik wybitny",
                "strength": "Mocna strona",
                "meets_standard": "Na poziomie firmy",
                "needs_attention": "Wymaga uwagi",
                "needs_development": "Obszar rozwoju"
            },
            "plan": {
                "month": "Miesiąc",
                "goals": "Cele",
                "actions": "Działania"
            },
            "colophon": {
                "built_on": "Raport powstał na podstawie sesji z okresu {from} — {to}. Łączna liczba sesji: {count}.",
                "comparison": "Porównanie dotyczy średniej firmy z tego samego okresu. Liczba uczestników: {count}."
            }
        }
    },
    "ranking": "Ranking",
    "analytics": "Analityka",
    "support": "Wsparcie",
    "users": "Użytkownicy",
    "participants": "Uczestnicy",
    "departments": "Działy",
    "positions": "Stanowiska",
    "user-custom-fields": "Pola niestandardowe",
    "administration": "Administracja",
    "ai-assistants": "Asystenci AI",
    "ai-prompts": "Podpowiedzi AI",
    "ai-profiles": "Profile AI",
    "ai-connectors": "Konektory AI",
    "Audit logs": "Dzienniki audytu",
    "organizations": "Organizacje",
    "loading": "Ładowanie...",
    "previous": "Poprzedni",
    "next": "Następny",
    "save": "Zapisz",
    "copy": "Kopiuj",
    "copy_failed": "Nie udało się skopiować automatycznie. Zaznacz tekst w polu i skopiuj go ręcznie (Ctrl+C lub ⌘C).",
    "confirm": "Potwierdź",
    "suggest": "Zaproponuj",
    "generate": "Generuj",
    "cancel": "Anuluj",
    "close": "Zamknij",
    "search": "Szukaj...",
    "accept": "Akceptuj",
    "propose": "Zaproponuj",
    "decline": "Odrzuć",
    "send_request": "Wyślij prośbę",
    "assign": "Przypisz",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Ekspert",
        "player": "Uczestnik",
        "manager": "Menedżer",
        "head": "Kierownik"
    },
    "statistics": {
        "date_from": "Od",
        "date_to": "Do",
        "competence": "Kompetencja",
        "evaluator": "Oceniający",
        "last_games_effectiveness": {
            "effectiveness": "Skuteczność",
            "title": "Postęp skuteczności"
        },
        "skill_trend": {
            "average_score": "Średni wynik",
            "game": "Sesja",
            "score": "Wynik",
            "title": "Średni wynik według kompetencji"
        },
        "player_competence_radar": {
            "title": "Statystyki umiejętności",
            "top": "Top 10",
            "players_in_company": "Uczestnicy w firmie",
            "by_games": "Analityka według sesji",
            "subtitle": "Porównanie ze średnią firmową",
            "filter": "Filtruj",
            "you": "Ty",
            "company": "Firma",
            "average_score": "średni wynik",
            "skills_counted": "na podstawie {counted} z {total} umiejętności"
        },
        "personal_radar": {
            "title": "Mój radar kompetencji",
            "subtitle": "Twoje umiejętności w porównaniu ze średnią organizacji"
        },
        "skill_gap_heatmap": {
            "title": "Mapa luk kompetencyjnych",
            "no_data": "Brak danych oceny dla wybranych filtrów"
        },
        "progress_over_time": {
            "title": "Postęp w czasie",
            "avg_score": "Średni wynik",
            "week": "Tydzień",
            "month": "Miesiąc",
            "no_data": "Brak danych dla wybranego okresu"
        },
        "department_aggregation": {
            "title": "Porównanie działów",
            "avg_score": "Średni wynik",
            "players": "Uczestnicy",
            "no_data": "Brak danych działów dla wybranych filtrów"
        },
        "employee_comparison": {
            "title": "Porównanie pracowników",
            "subtitle": "Porównaj oceny umiejętności dla 2–3 pracowników obok siebie",
            "select_players": "Wybierz 2–3 uczestników do porównania",
            "max_players": "Maksymalnie 3 uczestników"
        },
        "score_distribution": {
            "title": "Rozkład wyników",
            "subtitle": "Rozkład wyników oceny według kompetencji lub umiejętności",
            "count": "Oceny",
            "q1": "Q1",
            "median": "Mediana",
            "q3": "Q3",
            "average": "Średnia",
            "no_data": "Brak danych oceny dla wybranych filtrów"
        },
        "evaluator_consistency": {
            "title": "Spójność oceniających",
            "subtitle": "Korelacja i średnie wyniki według typów oceniających",
            "correlation": "Macierz korelacji",
            "correlation_method": "Pearsona",
            "avg_by_type": "Średnia według typu oceniającego",
            "pair_details": "Szczegóły par",
            "corr_label": "Korel.",
            "gap_label": "Różnica",
            "shared_label": "Wspólne",
            "no_data": "Niewystarczające dane oceny do obliczenia spójności"
        },
        "engagement_dashboard": {
            "title": "Panel zaangażowania",
            "subtitle": "Śledź intensywność aktywności i identyfikuj pracowników wymagających uwagi",
            "active_employees": "Aktywni pracownicy",
            "avg_games_week": "Śr. sesji / tydzień",
            "inactive_employees": "Nieaktywni pracownicy",
            "inactive_threshold_days": "Próg nieaktywności (dni)",
            "days_inactive": "{days} dni nieaktywności",
            "last_game_date": "Ostatnia sesja: {date}",
            "no_games_yet": "Brak sesji",
            "no_inactive": "Nie znaleziono nieaktywnych pracowników"
        },
        "strengths_weaknesses": {
            "title": "Mocne i słabe strony",
            "subtitle": "Twoje 3 najmocniejsze i najsłabsze umiejętności",
            "strengths": "Mocne strony",
            "weaknesses": "Obszary do poprawy",
            "no_data": "Niewystarczające dane oceny"
        },
        "peer_percentile": {
            "title": "Percentyl w grupie rówieśniczej",
            "subtitle": "Twoja pozycja według umiejętności w porównaniu do innych w organizacji",
            "top_percent": "Top {percent}%",
            "bottom_percent": "Dolne {percent}%",
            "no_data": "Niewystarczające dane do obliczenia percentyli"
        },
        "evaluation_gap": {
            "title": "Różnica między samooceną a oceną AI",
            "subtitle": "Porównaj swoją samoocenę z oceną AI, aby odkryć nieświadome obszary",
            "self_assessment": "Samoocena",
            "ai_evaluation": "Ocena AI",
            "gap": "Różnica",
            "skill": "Umiejętność",
            "no_data": "Brak danych — wymagane są zarówno samoocena, jak i ocena AI"
        },
        "improvement_velocity": {
            "title": "Tempo poprawy",
            "subtitle": "Zmiana wyniku: ostatnie 30 dni vs poprzednie 30 dni",
            "no_data": "Niewystarczające dane do obliczenia poprawy",
            "improved": "Poprawa",
            "declined": "Spadek"
        },
        "activity_calendar": {
            "title": "Kalendarz aktywności",
            "subtitle": "Dzienny udział w sesjach w ciągu ostatnich 6 miesięcy",
            "current_streak": "Bieżąca seria",
            "longest_streak": "Najdłuższa seria",
            "total_games": "Łączna liczba sesji",
            "games_count": "{count} sesji",
            "no_activity": "Brak aktywności w ciągu ostatnich 6 miesięcy"
        },
        "session_history": {
            "title": "Historia sesji",
            "subtitle": "Twoje ostatnie sesje i wyniki",
            "date": "Data",
            "scenario": "Scenariusz",
            "type": "Typ",
            "score": "Wynik",
            "status": "Status",
            "types": {
                "player_vs_player": "Uczestnik kontra uczestnik",
                "player_vs_ai": "Uczestnik kontra AI",
                "training": "Szkolenie"
            },
            "statuses": {
                "time_scheduling": "Ustalanie czasu rozpoczęcia",
                "waiting_for_start": "Oczekiwanie na start",
                "missed": "Nieobecność",
                "in_progress": "W toku",
                "protocol_approval": "Zatwierdzenie protokołu",
                "failed": "Nieudana",
                "completed": "Ukończona"
            }
        }
    },
    "org_activity": {
        "title": "Aktywność organizacji",
        "empty": "Brak aktywności w tym okresie",
        "search_placeholder": "Szukaj organizacji…",
        "chips": {
            "today": "Dziś",
            "week": "Tydzień",
            "all": "Wszystkie",
            "inactive": "Nieaktywna ≥7d"
        },
        "sort": {
            "recent": "Najnowsze",
            "least_active": "Najmniej aktywne",
            "az": "A–Z"
        },
        "card": {
            "plays_in_7_days": "{count} gier w ciągu 7 dni",
            "open_menu": "Otwórz menu",
            "open_audit_log": "Otwórz dziennik audytu"
        },
        "drawer": {
            "title": "Ostatnia aktywność",
            "open_audit_log": "Otwórz pełny dziennik audytu",
            "active_for": "Aktywna {time} temu",
            "summary": "{games} gier · {scenarios} scenariuszy · {ai_profiles} profili AI",
            "buckets": {
                "today": "Dziś",
                "yesterday": "Wczoraj",
                "this_week": "W tym tygodniu",
                "older": "Starsze"
            }
        },
        "events": {
            "game_created": "Rozegrana gra",
            "voice_session_created": "Sesja głosowa rozpoczęta",
            "scenario_created": "Scenariusz utworzony",
            "scenario_updated": "Scenariusz zaktualizowany",
            "ai_profile_created": "Profil AI utworzony",
            "profile_created": "Nowy pracownik zarejestrowany"
        }
    },
    "participant": {
        "upcoming_games": "Nadchodzące sesje",
        "for_rank_games": "Do oceny"
    },
    "roles": {
        "player": "Uczestnik",
        "admin": "SuperAdmin (system)",
        "scoped_admin": "Starszy administrator",
        "observer": "Obserwator",
        "captain": "Kapitan",
        "expert": "Ekspert",
        "lead_expert": "Starszy ekspert",
        "manager": "Menedżer",
        "support": "Wsparcie",
        "early_access": "Wczesny dostęp",
        "head": "Kierownik",
        "candidate": "Kandydat"
    },
    "user-status": {
        "active": "Aktywny",
        "inactive": "Nieaktywny",
        "pending": "Oczekujący"
    },
    "pagination": {
        "showing": "wyświetlanie",
        "to": "do",
        "of": "z",
        "entries": "wpisów"
    },
    "validator": {
        "required": "To pole jest wymagane",
        "library": "Rozmiar pliku musi być mniejszy niż 500 MB",
        "email": "Pole e-mail musi zawierać prawidłowy adres e-mail",
        "password": "Pole musi zawierać co najmniej jedną wielką literę, małą literę, znak specjalny i cyfrę, a minimalna długość wynosi 8 znaków",
        "confirm": "Potwierdzenie hasła nie pasuje",
        "at_least": "Pole musi zawierać co najmniej",
        "items": "elementów",
        "number": "To pole musi być liczbą całkowitą",
        "is_odd": "To pole musi być parzyste",
        "number_between": "Wprowadź liczbę z zakresu",
        "number_and": "i",
        "date_range_required": "Wymagany zakres dat",
        "invalid_date_range": "Nieprawidłowy zakres",
        "invalid_date_format": "Nieprawidłowy format daty",
        "start_date_after_end_date": "Data od musi być wcześniejsza niż data do",
        "max_180_days": "Maks. 180 dni"
    },
    "user": {
        "menu": {
            "settings": "Ustawienia",
            "statistics": "Statystyki",
            "logout": "Wyloguj się"
        }
    },
    "theme": {
        "system": "Systemowy",
        "light": "Jasny",
        "dark": "Ciemny"
    },
    "error": {
        "default": "Przepraszamy, wystąpił błąd. Nasi specjaliści zostali już poinformowani i naprawią go jak najszybciej.",
        "unauthorized": "Twoja sesja wygasła.",
        "contact-support": "Przepraszamy, wystąpił błąd. Skontaktuj się z pomocą techniczną",
        "forbidden": "Odmowa dostępu"
    },
    "confirmation": {
        "sure": "Czy na pewno chcesz usunąć ten wpis?",
        "sure_return_to_time_scheduling": "Czy na pewno chcesz przywrócić sesję do etapu ustalania czasu rozpoczęcia?",
        "sure_restore": "Czy na pewno chcesz przywrócić ten wpis?",
        "sure_mark_completed": "Czy na pewno chcesz oznaczyć tę sesję jako ukończoną?",
        "sure_mark_failed": "Oznaczyć grę jako nieudaną i trwale usunąć wszystkie oceny i protokoły uczestników?",
        "success": "Sukces!",
        "deleted": "Usunięto",
        "failed_marked": "Gra oznaczona jako nieudana",
        "restored": "Przywrócono",
        "cancel": "Anulowano",
        "yes": "Tak",
        "no": "Nie"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Witaj ponownie",
                "progress": "Twój ogólny postęp",
                "stats": {
                    "minutes": "Przepracowane minuty",
                    "effectiveness": "Ogólny wynik",
                    "completed_games_count": "Ukończone sesje",
                    "total_games_count": "Łączna liczba sesji"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Ranking firmowy",
                    "player": "Uczestnik",
                    "effectiveness": "Skuteczność"
                }
            }
        },
        "head": {
            "my_stats": "Moje statystyki",
            "subordinates": "Moi podwładni",
            "subordinate_stats": "Statystyki podwładnych",
            "select_subordinate": "Wybierz podwładnego, aby wyświetlić jego statystyki",
            "no_subordinates": "Brak przypisanych podwładnych"
        }
    },
    "chat-page": {
        "last_game": "Ostatnia sesja",
        "chats": "Czaty",
        "no-chats": "Nie znaleziono czatów",
        "contacts": "Kontakty",
        "choose": "Wybierz kontakt",
        "send": "Wyślij",
        "type": "Wpisz wiadomość...",
        "no-contacts": "Nie znaleziono kontaktów",
        "search": "Szukaj...",
        "start_conversation": "Rozpocznij rozmowę",
        "start_connecting": " Zacznij nawiązywać kontakty, wybierając jeden z kontaktów po lewej stronie"
    },
    "scenarios-page": {
        "title": "Tytuł",
        "export-docx": "Eksportuj .docx",
        "copy_title": "Kopiuj scenariusz",
        "generate_ai_title": "Generuj scenariusz AI",
        "organization": "Firma",
        "competence": "Kompetencja",
        "actions": " ",
        "add": "Dodaj scenariusz",
        "ai-generate": "Generuj AI",
        "copy": "Kopiuj scenariusz",
        "add_popup": "Dodaj scenariusz",
        "delete": "Usuń scenariusz",
        "edit": "Edytuj scenariusz",
        "edit_popup": "Edytuj scenariusz",
        "industries": [
            "FMCG/Handel detaliczny",
            "Farmacja",
            "Bankowość i fintech",
            "Hotele i turystyka",
            "Firmy IT/SaaS",
            "Gastronomia/HoReCa",
            "E-commerce/Marketplace",
            "Produkcja/Przemysł 4.0",
            "Logistyka i transport",
            "Telekomunikacja",
            "Edukacja/EdTech",
            "Przemysł chemiczny",
            "Oprogramowanie łańcucha dostaw",
            "Administracja publiczna/Organizacje non-profit"
        ],
        "case_types": [
            "Przywództwo i zarządzanie ludźmi",
            "Rekrutacja i ocena pracowników",
            "Sprzedaż i obsługa klienta",
            "Negocjacje i wpływ",
            "Zarządzanie konfliktem",
            "Strategia i realizacja"
        ],
        "cases": [
            [
                "Wyznaczanie celów SMART/OKR",
                "Udzielanie informacji zwrotnej rozwojowej (SBI/COIN)",
                "Delegowanie",
                "Coaching GROW",
                "Ocena efektywności",
                "Mentoring"
            ],
            [
                "Wywiad kompetencyjny (CBI)",
                "Assessment/Assessment Center",
                "Sesja wdrożeniowa (onboarding)"
            ],
            [
                "Klasyczna sprzedaż produktu/usługi",
                "Obsługa zastrzeżeń",
                "Upsell/Cross-sell",
                "Obsługa reklamacji",
                "Sprzedaż wielokanałowa"
            ],
            [
                "Negocjacje budżetu/zasobów korporacyjnych",
                "Umowa z klientem/dostawcą",
                "Negocjacje kryzysowe"
            ],
            [
                "Konflikt interpersonalny w zespole",
                "Menedżer–podwładny",
                "Konflikt wartości/etyczny"
            ],
            [
                "Priorytetyzacja portfela projektów",
                "Zarządzanie zmianą",
                "Analiza ryzyka"
            ]
        ],
        "formats": [
            "1-1",
            "Zespoły"
        ],
        "labels": {
            "industry": "Branża",
            "case_type": "Typ przypadku",
            "case": "Przypadek",
            "format": "Format",
            "duration": "Czas trwania (minuty)",
            "game_vs_ai": "Sesja kontra AI",
            "level": "Poziom",
            "competence": "Kompetencja",
            "description": "Opis scenariusza",
            "description_hint": "Opcjonalnie opisz scenariusz, który chcesz wygenerować (maks. 4000 znaków)"
        },
        "generating_in_progress": "Generowanie scenariusza, proszę czekać..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Tura",
            "full_name": "Uczestnik",
            "games_count": "Sesje",
            "team": "Zespół",
            "export": "Eksportuj",
            "effectiveness": "Skuteczność"
        }
    },
    "report-filters": {
        "department": "Dział",
        "position": "Stanowisko",
        "employee": "Pracownik",
        "scenario": "Scenariusz",
        "competence": "Kompetencja",
        "period": "Okres",
        "reset": "Resetuj",
        "only-period-competence": "Uwzględniane są tylko okres i kompetencja"
    },
    "competencies-page": {
        "title": "Tytuł",
        "export-docx": "Eksportuj .docx",
        "skills": "Umiejętności",
        "text": "Treść",
        "display_order": "Sortowanie",
        "ai-assistant": "Asystent AI",
        "language": "Język",
        "department": "Dział",
        "evaluation-target": "Kogo oceniamy?",
        "evaluation-both": "Oboje uczestnicy",
        "evaluation-team-a": "Tylko zespół A",
        "evaluation-both-tooltip": "Oceniani są oboje uczestnicy — odpowiednie dla scenariuszy negocjacyjnych",
        "evaluation-team-a-tooltip": "Oceniany jest tylko lider — format informacji zwrotnej",
        "actions": " ",
        "add": "Dodaj kompetencję",
        "add_popup": "Dodaj kompetencję",
        "delete": "Usuń kompetencję",
        "edit": "Edytuj kompetencję",
        "edit_popup": "Edytuj kompetencję"
    },
    "faq-page": {
        "title": "Pytania",
        "question": "Pytanie",
        "text": "Odpowiedź",
        "is_shared": "Dostępne dla wszystkich firm",
        "actions": " ",
        "add": "Dodaj pytanie",
        "add_popup": "Dodaj pytanie",
        "delete": "Usuń pytanie",
        "edit": "Edytuj pytanie",
        "edit_popup": "Edytuj pytanie",
        "visibility": "Widoczność",
        "visible_to_all": "Widoczne dla wszystkich użytkowników",
        "visible_to_managers": "Widoczne tylko dla menedżerów"
    },
    "ai-connectors-page": {
        "title": "Konektory AI",
        "is_shared": "Dostępne dla wszystkich organizacji",
        "actions": " ",
        "add": "Dodaj konektor",
        "add_popup": "Dodaj konektor",
        "delete": "Usuń konektor",
        "edit": "Edytuj konektor",
        "edit_popup": "Edytuj konektor",
        "label": "Etykieta",
        "provider": "Dostawca",
        "service": "Usługa",
        "organization": "Organizacja",
        "status": "Status",
        "region": "Region",
        "endpoint": "Endpoint",
        "secret": "Hasło/Klucz",
        "maxConcurrency": "Maks. współbieżność",
        "timeoutSec": "Limit czasu",
        "sortOrder": "Kolejność sortowania",
        "config": "Konfiguracja",
        "modelPrimary": "Model primary",
        "modelLight": "Model light",
        "modelLightHint": "Puste — wywołania light korzystają z modelu primary",
        "folderId": "ID folderu",
        "models": "Modele",
        "is_default": "Domyślny",
        "notes": "Uwagi"
    },
    "skills-page": {
        "title": "Tytuł",
        "display_order": "Sortowanie",
        "competence": "Kompetencja",
        "text": "Wskaźniki",
        "actions": " ",
        "add": "Dodaj umiejętność",
        "add_popup": "Dodaj umiejętność",
        "delete": "Usuń umiejętność",
        "edit": "Edytuj umiejętność",
        "edit_popup": "Edytuj umiejętność"
    },
    "departments-page": {
        "title": "Tytuł",
        "actions": " ",
        "add": "Dodaj dział",
        "add_popup": "Dodaj dział",
        "delete": "Usuń dział",
        "edit": "Edytuj dział",
        "edit_popup": "Edytuj dział"
    },
    "tours-page": {
        "title": "Tytuł",
        "actions": " ",
        "add": "Dodaj turę",
        "add_popup": "Dodaj turę",
        "delete": "Usuń turę",
        "edit": "Edytuj turę",
        "edit_popup": "Edytuj turę"
    },
    "library-page": {
        "title": "Tytuł",
        "text": "Opis",
        "video": "Wideo",
        "courses": "Kursy",
        "video_link_copy": "Kopiuj link",
        "video_in_process": "Wideo jest przetwarzane...",
        "is_public": "Publiczne",
        "actions": " ",
        "add": "Dodaj wideo",
        "add_popup": "Dodaj wideo",
        "delete": "Usuń wideo",
        "edit": "Edytuj wideo",
        "edit_popup": "Edytuj wideo"
    },
    "library-documents-page": {
        "title": "Tytuł",
        "actions": " ",
        "add": "Dodaj dokument",
        "add_popup": "Dodaj dokument",
        "delete": "Usuń dokument",
        "edit": "Edytuj dokument",
        "edit_popup": "Edytuj dokument",
        "file": "Plik"
    },
    "scorm-page": {
        "title": "Tytuł",
        "actions": " ",
        "add": "Dodaj kurs",
        "loading": "Kurs jest ładowany...",
        "add_popup": "Dodaj kurs",
        "delete": "Usuń kurs",
        "edit": "Edytuj kurs",
        "edit_popup": "Edytuj kurs",
        "zip_file": "Plik ZIP"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "description": "Opis",
        "actions": " ",
        "add": "Dodaj asystenta AI",
        "add_popup": "Dodaj asystenta AI",
        "delete": "Usuń asystenta AI",
        "edit": "Edytuj asystenta AI",
        "edit_popup": "Edytuj asystenta AI"
    },
    "ai-prompts-page": {
        "name": "Nazwa",
        "content": "Treść",
        "actions": " ",
        "add": "Dodaj podpowiedź AI",
        "add_popup": "Dodaj podpowiedź AI",
        "delete": "Usuń podpowiedź AI",
        "edit": "Edytuj podpowiedź AI",
        "edit_popup": "Edytuj podpowiedź AI",
        "key": "Klucz slotu",
        "model": "Model",
        "updated_at": "Zaktualizowano",
        "custom": "Niestandardowy",
        "description": "Opis",
        "temperature": "Temperature",
        "top_p": "Top P",
        "reasoning_effort": "Wysiłek rozumowania",
        "reasoning_effort_default": "Domyślny",
        "required_placeholders": "Wymagane placeholdery (muszą występować w treści)",
        "versions": "Historia wersji",
        "no_versions": "Brak wersji",
        "restore": "Przywróć",
        "restore_confirm": "Przywrócić tę wersję? Jej treść stanie się bieżącą.",
        "restored": "Wersja przywrócona",
        "current_version": "Bieżąca",
        "author": "Autor",
        "error": "Coś poszło nie tak.",
        "tab_system": "Systemowe",
        "tab_custom": "Niestandardowe",
        "system_hint": "Systemowe prompty są używane przez kod platformy. Nie można ich usunąć, ale można edytować ich treść.",
        "custom_hint": "Niestandardowe prompty są przypisane do kompetencji i profili AI jako nadpisanie promptu oceny.",
        "model_from_code": "ustawiony przez kod",
        "model_from_code_hint": "Model jest wybierany przez kod korzystający z promptu; nie jest przechowywany w samym prompcie.",
        "used_by": "Używany przez",
        "used_by_value": "Kompetencje: {competencies}, Profile AI: {profiles}",
        "not_used": "Nieużywany",
        "delete_blocked_hint": "Nie można usunąć: prompt jest używany jako nadpisanie. {usage}",
        "slot_description": {
            "game_eval_negotiation": "Ocena AI gier PvP: negocjacje",
            "game_eval_feedback": "Ocena AI gier PvP: informacje zwrotne",
            "game_eval_vs_ai": "Ocena AI gier przeciwko AI (gdy profil AI nie ma nadpisania)",
            "protocol_evaluation": "Wypełnianie protokołu scenariusza na podstawie transkryptu gry przeciwko AI",
            "voice_agent": "Systemowy prompt głosowego rozmówcy AI",
            "scenario_generation": "Generowanie scenariusza z opisu",
            "scenario_card_update": "Aktualizacja karty scenariusza z opisu AI",
            "scenario_optimize": "Optymalizacja opisu AI scenariusza",
            "skill_report_analysis": "Raport umiejętności: krok analizy",
            "skill_report_recommendations": "Raport umiejętności: krok rekomendacji"
        }
    },
    "ai-profiles-page": {
        "name": "Nazwa",
        "settings": "Ustawienia",
        "temperature": "Kreatywność",
        "demeanor": "Temperament",
        "behavior": "Zachowanie, instrukcje",
        "background": "Biografia",
        "style": "Styl",
        "instructions": "Instrukcje",
        "supportive_phrases": "Zwroty wspierające",
        "ai_assistant": "Asystent AI",
        "ai_starts_first": "AI zaczyna pierwsza",
        "first_phrase": "Pierwsza fraza",
        "closing_phrases": "Frazy zamykające",
        "voice": "Głos",
        "expert_mode": "Tryb eksperta",
        "custom_demeanor_hint": "Aktualny niestandardowy temperament",
        "is_shared": "Dostępne dla wszystkich organizacji",
        "voice_options": {
            "male": "Męski",
            "female": "Żeński"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Przyjazny",
                "description": "Łatwy w kontakcie i miły"
            },
            "critical": {
                "title": "Krytyczny",
                "description": "Często wskazuje wady i obszary do poprawy"
            },
            "empathetic": {
                "title": "Empatyczny",
                "description": "Bardzo wrażliwy na uczucia i emocje innych"
            },
            "enthusiastic": {
                "title": "Entuzjastyczny",
                "description": "Wykazuje intensywne zaangażowanie i zapał"
            },
            "analytical": {
                "title": "Analityczny",
                "description": "Skupia się na logice i szczegółowym rozwiązywaniu problemów"
            },
            "curious": {
                "title": "Ciekawski",
                "description": "Chętny do nauki i zadawania pytań"
            },
            "assertive": {
                "title": "Asertywny",
                "description": "Pewny siebie i zdecydowany"
            },
            "blunt": {
                "title": "Bezpośredni",
                "description": "Mówi wprost i na temat"
            },
            "skeptical": {
                "title": "Sceptyczny",
                "description": "Nieufny wobec nowych rozwiązań i pomysłów"
            },
            "neutral": {
                "title": "Neutralny",
                "description": "Wyważony i obiektywny w komunikacji"
            },
            "casual": {
                "title": "Swobodny",
                "description": "Rozluźniony i konwersacyjny w tonie"
            }
        },
        "placeholders": {
            "name": "Na przykład: Marek (uprzejmy i przyjazny)",
            "demeanor": "Na przykład: Przyjazny, uprzejmy i towarzyski...",
            "background": "Na przykład: Był dwukrotnie zwalniany...",
            "behavior": "Na przykład: Nie przerywa, aktywnie słucha...",
            "first_phrase": "Na przykład: Dzień dobry! Jak się Pan/Pani czuje?",
            "closing_phrases": "Na przykład: Prawie nie mamy już czasu, więc proponuję szybko podsumować nasze spotkanie."
        },
        "actions": " ",
        "add": "Dodaj profil AI",
        "add_popup": "Dodaj profil AI",
        "subtitle": "Jak rozmówca wygląda i brzmi podczas sesji",
        "preview": {
            "title": "Podgląd",
            "unnamed": "Bez imienia",
            "voice": "głos {name}",
            "defaultVoice": "głos domyślny",
            "defaultPhoto": "Domyślne zdjęcie",
            "listen": "Odsłuchaj głos",
            "defaultVoiceNotice": "Głos zostanie dobrany na początku sesji — nie można go wcześniej odsłuchać",
            "photoPlaceholder": "Tu pojawi się zdjęcie"
        },
        "delete": "Usuń profil AI",
        "edit": "Edytuj profil AI",
        "edit_popup": "Edytuj profil AI",
        "avatar_hint": "zdjęcie awatara",
        "avatar_save_first": "Zapisz profil, aby umożliwić przesyłanie awatara",
        "avatar_requirements": "Maks. 1 MB • Zalecane: 1536×1024 • Proporcje: 3:2",
        "max_characters": "Maks. {max} znaków"
    },
    "games-page": {
        "game-with-ai": "Odgrywanie ról z AI",
        "organization": "Organizacja",
        "status": "Status",
        "failure_reasons": {
            "protocol_not_agreed": "Uczestnicy nie uzgodnili protokołu oceny",
            "protocol_approval_expired": "Czas na uzgodnienie protokołu upłynął",
            "annulled": "Sesja została anulowana przez administratora",
            "expired": "Upłynął czas sesji",
            "assignment_changed": "Przypisanie kursu w systemie szkoleniowym zostało zmienione"
        },
        "restore": "Przywróć",
        "play": "Zagraj",
        "meetings_unavailable": "Sesje wideo między uczestnikami są tymczasowo niedostępne. Spróbuj ponownie później.",
        "import": "Importuj",
        "scenario": "Scenariusz",
        "tour": "Tura",
        "game_types": {
            "classic": "Tryb klasyczny",
            "vs_ai": "Odgrywanie ról z AI",
            "uploaded_recording": "Nagranie"
        },
        "upload_recording": {
            "file": "Plik nagrania",
            "file_hint": "Wideo lub audio, do 1 GB",
            "uploaded": "Plik przesłany",
            "file_too_large": "Plik przekracza 1 GB",
            "upload_error": "Nie udało się przesłać pliku",
            "player": "Uczestnik",
            "rate_both": "Oceń obu uczestników",
            "second_player": "Drugi uczestnik",
            "open_session": "Otwórz sesję"
        },
        "game_targets": {
            "user": "Uczestnik",
            "position": "Stanowisko",
            "department": "Dział"
        },
        "number": "Numer",
        "start_up_to": "Rozpocznij do",
        "start_time": "Czas rozpoczęcia",
        "teamA": "Zespół A",
        "teamB": "Zespół B",
        "others": "Uczestnicy",
        "actions": " ",
        "edit_results": "Zmień wyniki",
        "add": "Dodaj sesję",
        "add_popup": "Dodaj sesję",
        "delete": "Usuń sesję",
        "edit": "Edytuj sesję",
        "edit_popup": "Edytuj sesję",
        "time_scheduling": "Ustalanie czasu rozpoczęcia",
        "return_to_time_scheduling": "Powróć do ustalania czasu rozpoczęcia",
        "preparation": "Przygotowanie do sesji",
        "view_scenario": "Wyświetl scenariusz",
        "protocol": "Zatwierdzenie protokołu",
        "not_agreed": "Nieuzgodnione",
        "expert-accept": "Zaakceptuj i przejdź do oceny",
        "expert-decline": "Odrzuć",
        "hide_ai_results": "Ukryj wyniki AI",
        "show_ai_results": "Pokaż wyniki AI",
        "mark_completed": "Oznacz jako ukończone",
        "mark_failed": "Zakończ niepowodzeniem",
        "popup": {
            "start_up_to": "Rozpocznij do",
            "target": "Do kogo przypisać sesję?",
            "custom_field_value": "Wartość pola „{field}”",
            "target_preview_count": "Sesje do utworzenia: {count}",
            "target_preview_empty": "Żaden gracz nie pasuje do tego segmentu — nie zostanie utworzona żadna sesja",
            "target_preview_limit_exceeded": "To więcej, niż można utworzyć w jednym przypisaniu (maksymalnie {limit}). Zmniejsz wycinek, liczbę przypadków lub liczbę kopii",
            "copies_per_player": "Kopie każdego przypadku na gracza",
            "position": "Stanowisko",
            "department": "Dział",
            "scenario": "Scenariusz",
            "optional": "Opcjonalne, można pominąć",
            "protocol_time": "Czas protokołu",
            "protocol_time_hint": "Liczba od 1 do 1440",
            "preparation_time": "Czas przygotowania",
            "preparation_time_hint": "W minutach",
            "game_duration": "Czas trwania sesji",
            "game_duration_hint": "Liczba od 1 do 60",
            "is_team": "Scenariusz dla zespołów",
            "is_camera_required": "Kamery uczestników są wymagane",
            "is_self_rated": "Uczestnicy mogą oceniać samych siebie",
            "is_each_other_rated": "Uczestnicy mogą oceniać nawzajem",
            "is_expert_rated": "Ocena eksperta dostępna",
            "is_ai_rated": "Ocena AI dostępna",
            "show_results": "Pokaż wyniki",
            "automatically": "automatycznie",
            "manually": "ręcznie",
            "is_public_hint": "Każdy obserwator będzie mógł dołączyć",
            "is_public": "Sesja publiczna",
            "team_a": "Zespół A",
            "team_b": "Zespół B",
            "player_a": "Uczestnik A",
            "player_b": "Uczestnik B",
            "expert": "Ekspert",
            "observers": "Obserwatorzy",
            "tour": "Tura",
            "search": "Szukaj...",
            "choose_players": "Wybierz uczestników",
            "choose_expert": "Wybierz eksperta",
            "choose_observers": "Wybierz obserwatorów",
            "choose_scenario": "Wybierz scenariusz",
            "choose_tour": "Wybierz turę",
            "expert_empty": "Jeśli nie wybrano, kapitan będzie mógł wybrać",
            "captain": "Kapitan",
            "": "",
            "protocol": {
                "title": "Zatwierdzenie protokołu",
                "target": "Cel",
                "await_approval": "Oczekiwanie na zatwierdzenie przez drugą stronę",
                "await_proposal": "Oczekiwanie na propozycję drugiej strony",
                "questions": "Pytania dla Twojego zespołu",
                "questions_a": "Pytania dla zespołu A",
                "questions_b": "Pytania dla zespołu B",
                "not_agreed": "Nie doszli do porozumienia",
                "not_agreed_confirm": "Sesja zakończy się niepomyślnie i wyniki nie zostaną policzone. Ta czynność jest nieodwracalna.",
                "not_agreed_done": "Sesja zakończyła się niepomyślnie."
            },
            "start_time": {
                "title": "Czas rozpoczęcia",
                "must_start_by": "Musi się rozpocząć do"
            },
            "edit_results": {
                "title": "Zmień wyniki"
            },
            "preparation": {
                "title": "Przygotowanie do sesji",
                "description": "Opis",
                "description_team": "Opis zespołu",
                "notes": "Osobiste notatki"
            },
            "import": {
                "download_example": "Pobierz przykład",
                "title": "Import sesji",
                "button": "Rozpocznij import",
                "label": "Plik Excel",
                "file_size_error": "Rozmiar pliku nie może przekraczać 10 MB"
            },
            "create_multi_scenario_games_immediately": "Wszystkie sesje zostaną utworzone natychmiast",
            "create_multi_scenario_games_sequentially": "Sesje będą tworzone sekwencyjnie (po pomyślnym ukończeniu każdej z nich)"
        }
    },
    "ai-game": {
        "title": "Odgrywanie ról z AI",
        "recording": "Nagranie",
        "ai": "AI",
        "you": "Ty",
        "ai_ready": "Gotowy",
        "camera_off": "Kamera wyłączona",
        "stop_game": "Zatrzymaj",
        "start_game": "Rozpocznij",
        "mic_permission": "Przyznaj uprawnienia do mikrofonu w ustawieniach, aby rozpocząć sesję",
        "permissions_granted": "Uprawnienia przyznane pomyślnie!",
        "close": "Zamknij",
        "microphone_required": "Przyznaj uprawnienia do mikrofonu, aby rozpocząć sesję",
        "mic_required": "Włącz mikrofon, aby rozpocząć sesję",
        "mic_not_detected": "Nie wykryto dźwięku — spróbuj mówić lub sprawdź mikrofon",
        "permissions_needed": "Wymagany dostęp do mikrofonu. Kamera jest opcjonalna",
        "dialog_history": "Historia dialogu",
        "agent": {
            "initializing": "Inicjowanie...",
            "listening": "Słucham",
            "thinking": "Myślę...",
            "speaking": "Mówię",
            "waiting": "Oczekiwanie na agenta..."
        },
        "waiting_for_start": "Rozpocznij sesję, aby zacząć rozmowę",
        "grant_microphone": "Przyznaj dostęp do mikrofonu",
        "game_not_found": "Nie znaleziono sesji",
        "game_not_found_desc": "Nie można znaleźć sesji o ID {id}.",
        "confirm": {
            "start_question": "Czy na pewno? Sesji nie można wstrzymać",
            "start_title": "Sesja rozpoczęta",
            "start_success": "Sesja została pomyślnie rozpoczęta",
            "start_cancel_title": "Sesja nie została rozpoczęta",
            "start_cancel_msg": "Rozpoczęcie sesji zostało anulowane",
            "end_question": "Czy na pewno? Sesja zostanie zakończona",
            "end_title": "Sesja zakończona",
            "end_success": "Sesja została pomyślnie zakończona",
            "end_cancel_title": "Sesja nie została zakończona",
            "end_cancel_msg": "Zakończenie sesji zostało anulowane"
        },
        "voice": {
            "disconnected": "Rozłączono",
            "connecting": "Łączenie...",
            "connection_lost_permanently": "Utracono połączenie. Sesja zakończona z powodu problemów z siecią.",
            "connected": "Połączono z serwerem",
            "connection_error": "Nie udało się połączyć z agentem głosowym",
            "game_already_finished": "Ta gra już się zakończyła",
            "connection_timeout": "Upłynął limit czasu połączenia z serwerem głosowym. Może to być spowodowane zaporą sieciową lub ograniczeniami sieci. Sprawdź ustawienia sieci i spróbuj ponownie.",
            "no_rooms_available": "Brak dostępnych pokoi w tej chwili. Spróbuj ponownie później.",
            "preparing_recording": "Przygotowywanie nagrania, ponowna próba za {seconds} s…",
            "recording_service_overloaded": "Usługa nagrywania jest przeciążona. Spróbuj ponownie za kilka minut.",
            "session_quota_exhausted": "Pakiet sesji Twojej organizacji został wyczerpany. Skontaktuj się z menedżerem.",
            "connection_blocked": "Twoja sieć zablokowała konfigurację połączenia AI. Zezwól na HTTPS (443) dla wymaganych domen i spróbuj ponownie.",
            "connection_blocked_signaling": "Zapora sieciowa lub proxy blokuje połączenie z serwerem głosowym. Spróbuj połączyć się z innej sieci lub mobilnego hotspotu.",
            "reconnecting": "Ponowne łączenie...",
            "disconnect_dialog_title": "Utracono połączenie",
            "disconnect_dialog_message": "Połączenie zostało przerwane. Czy chcesz ponownie się połączyć, czy zakończyć sesję?",
            "disconnect_retry": "Połącz ponownie",
            "disconnect_finish": "Zakończ sesję",
            "agent_join_timeout": "Agent AI nie połączył się w wymaganym czasie. Spróbuj ponownie.",
            "stop_failed": "Nie udało się zatrzymać sesji",
            "mic_enable_failed": "Nie można włączyć mikrofonu. Możesz spróbować przełączyć go ręcznie.",
            "mic_toggle_failed": "Nie udało się przełączyć mikrofonu",
            "camera_toggle_failed": "Nie udało się przełączyć kamery",
            "duplicate_tab_title": "Sesja otwarta w innej karcie",
            "duplicate_tab_message": "Ta sesja jest już aktywna w innej karcie przeglądarki. Zamknij tamtą kartę i odśwież tę stronę, jeśli chcesz kontynuować tutaj.",
            "duplicate_tab_back": "Cofnij",
            "duplicate_tab_disconnect_title": "Otwarto w innej karcie",
            "duplicate_tab_disconnect_message": "Ta karta została rozłączona, ponieważ sesja jest już aktywna w innej karcie. Wróć do strony sesji stąd."
        },
        "pending_chunks_title": "Niezapisane dane nagrania",
        "pending_chunks_desc": "Istnieją niezapisane dane nagrania z poprzedniej sesji. Czy chcesz wznowić ich przesyłanie?",
        "pending_chunks_uploaded": "Wszystkie oczekujące nagrania zostały pomyślnie przesłane",
        "resume_upload": "Wznów przesyłanie",
        "skip": "Pomiń",
        "permissions_denied_safari": "Odmówiono dostępu do kamery lub mikrofonu. Przejdź do Ustawień Safari > Strony > Kamera/Mikrofon i zezwól na dostęp dla tej witryny.",
        "supported": "Przeglądarka obsługiwana"
    },
    "positions-page": {
        "title": "Tytuł",
        "actions": " ",
        "add": "Dodaj stanowisko",
        "add_popup": "Dodaj stanowisko",
        "delete": "Usuń stanowisko",
        "edit": "Edytuj stanowisko",
        "edit_popup": "Edytuj stanowisko"
    },
    "user-custom-fields-page": {
        "title": "Tytuł",
        "type": "Typ",
        "options_count": "Wartości",
        "actions": " ",
        "add": "Dodaj pole",
        "add_popup": "Dodaj pole",
        "delete": "Usuń pole",
        "delete_confirm": "Usunąć pole? Wartości zapisane u użytkowników przestaną być wyświetlane.",
        "edit": "Edytuj pole",
        "edit_popup": "Edytuj pole",
        "empty": "Nie ma jeszcze pól niestandardowych",
        "error": "Nie udało się zapisać pola",
        "type_text": "Tekst",
        "type_select": "Słownik",
        "type_locked_hint": "Typu nie można zmienić po utworzeniu pola",
        "options": "Wartości",
        "options_hint": "Kolejność wartości tutaj to kolejność na liście rozwijanej",
        "options_required": "Dodaj co najmniej jedną wartość",
        "option_title": "Wartość",
        "option_add": "Dodaj wartość",
        "option_delete": "Usuń wartość",
        "option_delete_confirm": "Usunąć wartość? Zostanie ona wyczyszczona u użytkowników, którzy ją wybrali.",
        "option_move_up": "Przenieś w górę",
        "option_move_down": "Przenieś w dół"
    },
    "organizations-page": {
        "name": "Nazwa",
        "host": "Host",
        "duel_limit": "Limit pojedynków",
        "max_users": "Maks. użytkowników",
        "max_users_hint": "0 = bez limitu",
        "max_vs_ai_games_per_scenario": "Maks. gier AI na gracza w scenariuszu",
        "max_vs_ai_games_per_scenario_hint": "Puste = brak limitu. Dotyczy samodzielnego tworzenia gier przez gracza",
        "employee_report_daily_limit": "Limit raportów pracowników na dobę",
        "employee_report_daily_limit_hint": "Puste = ogólny limit platformy. Dotyczy menedżerów i kierowników",
        "employee_report_hourly_limit": "Limit raportów pracowników na godzinę",
        "employee_report_hourly_limit_hint": "Puste = ogólny limit platformy. Dotyczy menedżerów i kierowników",
        "registration": "Rejestracja otwarta",
        "timezone": "Strefa czasowa",
        "locale": "Język regionalny",
        "users_count": "Użytkownicy",
        "actions": " ",
        "add": "Dodaj organizację",
        "add_popup": "Dodaj organizację",
        "delete": "Usuń organizację",
        "edit": "Edytuj organizację",
        "edit_popup": "Edytuj organizację",
        "available_languages": "Dostępne języki",
        "show_game_numbers_for_player": "Pokaż numery sesji uczestnikom",
        "allow_players_choose_expert": "Pozwól uczestnikom wybierać eksperta",
        "send_message": "Wyślij wiadomość do menedżerów",
        "message": "Wiadomość",
        "send": "Wyślij",
        "clear_message": "Wyczyść wiadomość",
        "current_message": "Bieżąca wiadomość",
        "two_factor_available": "Uwierzytelnianie dwuskładnikowe dostępne",
        "two_factor_method": "Metoda uwierzytelniania dwuskładnikowego",
        "two_factor_disabled": "Wyłączone",
        "two_factor_email": "E-mail",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Ukryte elementy menu",
        "hide_ai_results": "Ukryj wyniki AI",
        "hide_player_rating": "Ukryj ranking firmowy przed uczestnikami",
        "show_character_memory_to_player": "Pokaż graczowi pamięć postaci",
        "show_meeting_recap_to_player": "Pokaż graczowi podsumowanie spotkania",
        "create_user_on_external_launch": "Twórz użytkownika przy pierwszym żądaniu z systemu zewnętrznego",
        "create_user_on_external_launch_hint": "Po wyłączeniu uczestnik, który zgłasza się z systemu zewnętrznego po raz pierwszy, otrzyma odmowę zamiast gry. Każdy użytkownik utworzony w ten sposób zajmuje miejsce w subskrypcji.",
        "allow_external_email_linking": "Pozwól na powiązanie użytkownika zewnętrznego po adresie e-mail",
        "allow_external_email_linking_hint": "Po włączeniu osoba zewnętrzna zostanie powiązana z istniejącym już pracownikiem, jeśli system zewnętrzny przekazał jej adres e-mail ze swojego serwera. Po wyłączeniu takie żądanie zostanie odrzucone i nie zostanie utworzony drugi użytkownik z tym samym adresem."
    },
    "users-page": {
        "import": "Importuj",
        "user": "Użytkownik",
        "roles": "Role",
        "effectiveness": "Skuteczność",
        "department": "Dział",
        "position": "Stanowisko",
        "status": "Status",
        "actions": " ",
        "add": "Dodaj użytkownika",
        "add_popup": "Nowy użytkownik",
        "last_login_at": "Ostatnie logowanie",
        "delete": "Usuń",
        "view": "Wyświetl",
        "login": "Zaloguj",
        "message": "Wiadomość",
        "activate": "Aktywuj",
        "deactivate": "Zablokuj",
        "edit_popup": "Edytuj użytkownika",
        "total_in_org": "Łącznie w organizacji",
        "multi_role_note": "Użytkownik z kilkoma rolami jest liczony w każdej odznace",
        "filter_role": "Rola",
        "all_roles": "Wszystkie role",
        "filter_activity": "Ukończone scenariusze",
        "activity_played": "Tak",
        "activity_not_played": "Nie",
        "filter_activity_from": "Ukończone od",
        "filter_last_login_from": "Data logowania",
        "filter_custom_field": "Pole niestandardowe",
        "filter_custom_field_value": "Wartość pola „{field}”",
        "last_login_never": "Nigdy się nie logował",
        "last_login_since": "Logował się od",
        "cases_progress": "Ukończone przypadki",
        "cases_progress_value": "{completed} z {assigned}",
        "export": "Eksportuj",
        "popup": {
            "name": "Imię",
            "last_name": "Nazwisko",
            "patronymic": "Drugie imię",
            "phone": "Telefon",
            "timezone": "Strefa czasowa",
            "language": "Język",
            "country": "Kraj",
            "invalid_phone": "Nieprawidłowy numer telefonu",
            "department": "Dział",
            "position": "Stanowisko",
            "effectiveness": "Skuteczność",
            "roles": "Role",
            "organizations": "Organizacje",
            "blocked": "Zablokowany",
            "is_active": "Aktywny",
            "email_verified": "E-mail zweryfikowany",
            "email_not_verified": "E-mail niezweryfikowany",
            "subordinates": "Podwładni",
            "search_subordinates": "Szukaj uczestników...",
            "import": {
                "download_example": "Pobierz przykład",
                "title": "Import użytkowników",
                "button": "Rozpocznij import",
                "label": "Plik Excel",
                "marker_hint": "W przypadku istniejącego już użytkownika pusta komórka zachowuje bieżącą wartość, a myślnik (-) czyści pole.",
                "result_title": "Import uruchomiony",
                "result_created": "Zostanie utworzonych: {count}",
                "result_updated": "Zostanie zaktualizowanych: {count}",
                "result_skipped": "Pominięto: {count}",
                "result_skipped_row": "Wiersz {row}, {email}: {reason}",
                "result_truncated": "…i jeszcze {count} pominiętych wierszy"
            }
        }
    },
    "users-ranking-page": {
        "user": "Użytkownik",
        "roles": "Role",
        "effectiveness": "Skuteczność",
        "average-effectiveness": "Średnia na sesję",
        "sessions-count": "Sesje",
        "department": "Dział",
        "position": "Stanowisko",
        "status": "Status",
        "export": "Eksportuj",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Ukończone sesje",
        "not_found": "Użytkownik nie został znaleziony",
        "games_total": "Łącznie",
        "username": "Nazwa użytkownika",
        "phone": "Telefon",
        "status": "Status",
        "language": "Język",
        "timezone": "Strefa czasowa",
        "edit": "Edytuj",
        "department": "Dział",
        "position": "Stanowisko",
        "activate": "Aktywuj",
        "block": "Zablokuj",
        "account": {
            "title": "Konto",
            "summary": {
                "title": "Podsumowanie",
                "games": "Rozegrane sesje",
                "place": "Miejsce",
                "effectiveness": "Skuteczność",
                "time": "Czas"
            }
        },
        "security": {
            "title": "Bezpieczeństwo",
            "change_password_title": "Zmień hasło",
            "change_password": "Zmień hasło",
            "new_password": "Nowe hasło",
            "confirm_new_password": "Potwierdź nowe hasło",
            "password_requirements": "Wymagania dotyczące hasła:",
            "password_requirements_1": "Minimum 8 znaków — im więcej, tym lepiej",
            "password_requirements_2": "Co najmniej jedna mała litera",
            "password_requirements_3": "Co najmniej jedna cyfra, symbol lub spacja"
        },
        "statistics": {
            "title": "Statystyki"
        }
    },
    "game": {
        "character_memory": {
            "title": "Co pamięta postać",
            "subtitle": "Pamięć o poprzednich spotkaniach, z którą postać przystępuje do tej gry",
            "preview_subtitle": "Pamięć nie została jeszcze zapisana — postać otrzyma ją w momencie rozpoczęcia gry",
            "unavailable": "Poprzednie spotkanie jest niedostępne dla postaci: rozpocznie ona rozmowę, nie pamiętając go.",
            "agreements": "Ustalenia",
            "player_commitments": "Zobowiązania gracza",
            "character_commitments": "Zobowiązania postaci",
            "open_issues": "Otwarte kwestie",
            "facts": "Wymienione fakty",
            "attitude": "Stosunek do gracza",
            "evaluation_passed": "Postaci przekazano wyniki oceny tamtego spotkania",
            "evaluation_not_ready": "Ocena tamtego spotkania nie jest jeszcze gotowa — postać otrzyma ją, gdy zostanie obliczona.",
            "evaluation_hidden": "Teksty oceny są ukryte ustawieniami organizacji.",
            "overall_effectiveness": "Ogólna skuteczność",
            "outcome": {
                "deal": "Porozumienie",
                "partial": "Częściowo",
                "no_deal": "Bez porozumienia",
                "unclear": "Wynik niejasny"
            }
        },
        "meeting_recap": {
            "title": "Podsumowanie spotkania",
            "outcome": "Wynik",
            "agreements": "Ustalenia",
            "player_commitments": "Zobowiązania gracza",
            "character_commitments": "Zobowiązania postaci",
            "open_issues": "Otwarte kwestie",
            "facts": "Wymienione fakty",
            "pending": "Podsumowanie spotkania jest jeszcze w przygotowaniu. Wróć tu trochę później.",
            "unavailable": "Nie udało się przygotować podsumowania tego spotkania.",
            "none": "Dla tej gry nie ma podsumowania."
        },
        "title": "Sesja",
        "team": "Zespół",
        "expert": "Ekspert",
        "points": "punkty",
        "your_result": "Twój wynik",
        "joined_at": "Dołączono:",
        "ended_at": "Data zakończenia",
        "min": "min.",
        "duration": "Czas trwania",
        "from_average": "od średniej",
        "ai_expert": "Ekspert AI",
        "ai_evaluation_in_progress": "Trwa ocena AI",
        "delete_ai_request": "Usuń informację zwrotną AI",
        "ai_expert_refresh": "Odśwież wyniki AI",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "Nie można teraz odświeżyć wyników AI: ocena AI wciąż trwa.",
            "answer_pending": "Nie można teraz odświeżyć wyników AI: odpowiedź AI jeszcze nie dotarła.",
            "recognition_pending": "Nie można teraz odświeżyć wyników AI: nagranie jest wciąż transkrybowane.",
            "recognition_has_no_speech": "W nagraniu nie rozpoznano mowy, więc nie można odświeżyć wyników AI.",
            "recognition_has_too_little_speech": "W nagraniu prawie nie ma rozmowy uczestników, więc ocena AI nie została przeprowadzona.",
            "no_ai_evaluation": "Ta sesja nie ma już oceny AI.",
          "game_evaluation_blocked": "Sesja się nie odbyła lub została anulowana, więc ocena AI jest niedostępna."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "W nagraniu nie rozpoznano mowy, więc ocena AI nie została przeprowadzona.",
            "recognition_has_too_little_speech": "W nagraniu prawie nie ma rozmowy uczestników, więc ocena AI nie została przeprowadzona.",
          "game_evaluation_blocked": "Sesja się nie odbyła lub została anulowana, więc ocena AI jest niedostępna."
        },
        "ai_expert_refresh_failed": "Nie udało się odświeżyć wyników AI.",
        "speaker_mapping": {
            "title": "Uczestnicy i głosy",
            "voice": "Głos {number}",
            "unknown": "Nie określono",
            "needs_review": "Sprawdź uczestników",
            "needs_review_hint": "Uczestnicy mogli zostać określeni nieprawidłowo: upewnij się, że informacja zwrotna AI trafiła do właściwych osób.",
            "failed": "Nie udało się automatycznie określić uczestników.",
            "unavailable": "Dostawca AI był niedostępny; uczestnicy zostaną określeni przy następnej ocenie.",
            "empty": "Transkrypcja nie zawiera wypowiedzi, na podstawie których można określić uczestników.",
            "corrected_manually": "Poprawiono ręcznie",
            "under_reevaluation": "Trwa ocena AI z tymi uczestnikami. Dopóki się nie zakończy, na stronie widoczne są poprzednie wyniki.",
            "confirm": "Uczestnicy są poprawni",
            "review": "Sprawdź",
            "dialog_hint": "Przypisz uczestnika do każdego głosu. Po zapisaniu informacja zwrotna AI zostanie zażądana ponownie.",
            "save": "Zapisz",
            "cancel": "Anuluj",
            "confirmed": "Uczestnicy potwierdzeni",
            "fixed": "Uczestnicy poprawieni, informacja zwrotna AI zażądana ponownie",
            "action_failed": "Nie udało się wykonać akcji"
        },
        "ai_expert_created": "Proces oceny sesji został rozpoczęty. Potrwa to kilka minut. Możesz opuścić stronę — wyślemy Ci powiadomienie, gdy ocena będzie dostępna.",
        "expert_already_requested": "Ocena została już zlecona przez innego uczestnika",
        "request_expert": "Poproś o eksperta",
        "assign_expert": "Przypisz eksperta",
        "ai_process": "Proszę czekać, przetwarzanie",
        "analyzing_results": "Analizowanie wyników sesji...",
        "complete_expert_request": "Zakończ ocenę",
        "tabs": {
            "description": {
                "title": "Opis scenariusza",
                "subtitle": "Informacje o sesji i zasady",
                "situation": "Sytuacja",
                "your_role": "Twoja rola",
                "player_role": "Rola uczestnika: {name}",
                "team_tab": "Zespół {team}",
                "empty": "W tej sesji nie ma opisów.",
                "load_error": "Nie udało się wczytać opisu. Spróbuj ponownie później."
            },
            "results": {
                "title": "Wyniki",
                "effectiveness_summary": "Skuteczność zespołu",
                "your_effectiveness": "Twoja skuteczność",
                "parameters_section": "Parametry",
                "parameter": "Parametr",
                "target": "Cel",
                "coefficient": "Współczynnik",
                "value": "Porozumienie",
                "points": "Punkty",
                "points_short": "pkt",
                "combinations": "Kombinacje",
                "combination_bonus": "Bonus kombinacji",
                "questions": "Pytania",
                "question": "Pytanie",
                "answer": "Odpowiedź",
                "total": "Łącznie"
            },
            "comments": {
                "title": "Analiza wideo",
                "comments": "Komentarze",
                "no_comments": "Brak komentarzy",
                "no_video": "Wideo niedostępne",
                "video_processing": "Wideo jest przetwarzane...",
                "count": "komentarzy",
                "delete": "Usuń",
                "edit": "Edytuj",
                "popup": {
                    "add": "Dodaj komentarz",
                    "edit": "Edytuj komentarz",
                    "comment": "Komentarz",
                    "player": "Uczestnik",
                    "all": "Do wszystkich"
                }
            },
            "feedback": {
                "title": "Ocena sesji",
                "no_feedback": "Brak ocen",
                "no_feedback_description": "Informacja zwrotna dla tej sesji nie została jeszcze dodana",
                "overall_score": "Ogólny wynik",
                "skills_evaluated": "{count} ocenionych umiejętności",
                "no_comment": "Brak komentarza",
                "score_button": "Oceń uczestnika",
                "player": "Uczestnik",
                "author": "Autor",
                "download": "Pobierz wideo",
                "download_transcript": "Pobierz transkrypcję",
                "evaluators": {
                    "ai": "Ekspert",
                    "expert": "Ekspert",
                    "player": "Uczestnik",
                    "manager": "Menedżer",
                    "head": "Kierownik"
                },
                "popup": {
                    "score": {
                        "title": "Ocena uczestnika",
                        "comment": "Komentarz",
                        "error": "Musisz ocenić wszystkie umiejętności uczestnika",
                        "save_error": "Nie udało się zapisać oceny. Możliwe, że nie masz uprawnień do oceny tego uczestnika."
                    }
                }
            },
            "checklist": {
                "title": "Lista kontrolna",
                "total": "Zaliczone pozycje",
                "pass": "Zaliczono",
                "fail": "Niezaliczono",
                "cannot_assess": "Nie można ocenić",
                "comment": "Komentarz ogólny",
                "category": "Kategoria",
                "author": "Oceniający",
                "player": "Uczestnik",
                "passed_of": "{passed} z {total}",
                "evidence": "Dowód",
                "rationale": "Uzasadnienie",
                "no_results": "Ocena według listy kontrolnej nie jest jeszcze gotowa",
                "no_results_description": "Ta sesja nie została jeszcze oceniona za pomocą listy kontrolnej"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Utwórz nowy",
                "edit_ai_profile": "Edytuj",
                "delete_ai_profile": "Usuń",
                "confirm_delete_ai_profile": "Czy na pewno chcesz usunąć ten profil AI?",
                "first_header": "Podstawowe ustawienia",
                "second_header": "Gracz AI",
                "third_header": "Opis scenariusza",
                "is_public": "Publiczny",
                "is_public_hint": "Jeśli włączone — scenariusz będzie dostępny do wyboru przez uczestników.",
                "title": "Informacje",
                "subtitle": "Podstawowe dane scenariusza",
                "image": "zdjęcie scenariusza",
                "field_title": "Tytuł",
                "competence": "Kompetencja",
                "description": "Opis",
                "description_a": "Opis dla zespołu A",
                "description_b": "Opis dla zespołu B",
                "next_scenario_label": "Następny scenariusz",
                "next_scenario_placeholder": "Nie wybrano",
                "next_scenario_hint": "Po ukończeniu sesji z tym scenariuszem zostanie automatycznie utworzona sesja z następnym scenariuszem.",
                "memory_header": "Powiązanie z kolejnym spotkaniem",
                "memory_group_evaluation": "Ocena kolejnego spotkania",
                "memory_group_character": "Postać kolejnego spotkania",
                "memory_pass_to_next": "pamięta to spotkanie",
                "memory_pass_to_next_hint": "Postać kolejnego scenariusza rozpocznie rozmowę jak ze znajomym: otrzyma krótkie podsumowanie tego spotkania, ustalenia, zobowiązania obu stron, otwarte kwestie i wymienione fakty. Nagranie rozmowy i dosłowne cytaty nie są jej przekazywane. Opcję warto włączyć, gdy kolejne spotkanie jest kontynuacją tego: druga runda negocjacji, cykliczne spotkanie jeden na jeden.",
                "memory_pass_evaluation_to_next": "zna wyniki oceny tego spotkania",
                "memory_pass_evaluation_to_next_hint": "Wraz z pamięcią postać otrzyma teksty informacji zwrotnej dotyczące umiejętności oraz ogólny wynik tego spotkania i będzie mogła zachowywać się jak coach, który pamięta, co udało się graczowi.",
                "memory_evaluate_next_with_agreements": "uwzględnia ustalenia tego spotkania",
                "memory_evaluate_next_with_agreements_hint": "Podczas oceny kolejnego spotkania ekspert AI zobaczy ustalenia, zobowiązania obu stron i otwarte kwestie z tego spotkania oraz będzie mógł sprawdzić, czy gracz dotrzymał obietnic. Punkty i teksty poprzedniej oceny nie są przekazywane ekspertowi, aby nie wpływały na nową ocenę.",
                "ai_profile": "Profil AI",
                "ai_profile_placeholder": "Tylko dla sesji z AI",
                "ai_description": "Opis AI",
                "optimize_ai_description": "Optymalizuj z AI",
                "optimizing_in_progress": "AI optymalizuje opis. Proszę czekać...",
                "optimize_error": "Nie udało się zoptymalizować opisu. Spróbuj ponownie.",
                "ai_description_hint": "Pisanie skutecznego promptu AI wymaga doświadczenia. Źle napisany prompt może prowadzić do nieprzewidywalnego zachowania scenariusza. Jeśli nie masz pewności, użyj przycisku \"Optymalizuj z AI\", wypróbuj funkcję generowania scenariuszy lub skontaktuj się ze swoim menedżerem.",
                "knowledge_base_header": "Baza wiedzy",
                "knowledge_base_documents": "Dokumenty bazy wiedzy",
                "knowledge_base_documents_hint": "Dołącz dokumenty, aby dostarczyć kontekst graczowi AI",
                "knowledge_base_no_documents": "Brak dostępnych dokumentów. Prześlij dokumenty na stronie \"Baza wiedzy\".",
                "knowledge_base_chunks": "{count} fragmentów",
                "knowledge_base_purpose_voice": "Sesja AI",
                "knowledge_base_purpose_eval": "Ocena"
            },
            "settings": {
                "title": "Ustawienia",
                "subtitle": "Konfiguracja scenariusza",
                "min_players": "Min. uczestników",
                "min_players_hint": "Liczba od 2 do 20",
                "max_players": "Maks. uczestników",
                "max_players_hint": "Liczba od 2 do 20",
                "protocol_time": "Czas protokołu (min)",
                "protocol_time_hint": "Liczba od 1 do 1440",
                "preparation_time": "Czas przygotowania (min)",
                "preparation_time_hint": "Liczba od 0 do 1440. 0 — opis jest od razu widoczny",
                "game_duration": "Czas trwania sesji (min)",
                "game_duration_hint": "Liczba od 1 do 60",
                "is_team": "Scenariusz dla zespołów",
                "is_camera_required": "Kamery uczestników są wymagane",
                "is_self_rated": "Uczestnicy mogą oceniać samych siebie",
                "is_each_other_rated": "Uczestnicy mogą oceniać nawzajem",
                "is_expert_rated": "Ocena eksperta dostępna",
                "is_ai_rated": "Ocena AI dostępna",
                "show_results": "Pokaż wyniki",
                "automatically": "automatycznie",
                "manually": "ręcznie"
            },
            "parameters": {
                "title": "Parametry",
                "subtitle": "Parametry uczestnika",
                "field_title": "Tytuł",
                "team_a": "Zespół A",
                "team_b": "Zespół B",
                "player_a": "Uczestnik A",
                "player_b": "Uczestnik B",
                "points": "Punkty",
                "ratio": "Współczynnik",
                "add": "Dodaj parametr"
            },
            "questions": {
                "title": "Pytania",
                "subtitle": "Pytania dla uczestników",
                "question": "Pytanie",
                "team": "Zespół",
                "team_placeholder": "Wybierz zespół",
                "answers": "Odpowiedzi",
                "points": "Punkty",
                "select_answers": "Wybierz odpowiedzi",
                "add_combination": "Dodaj kombinację",
                "add_question": "Dodaj pytanie"
            },
            "next": "Następny",
            "previous": "Poprzedni",
            "save": "Zapisz"
        },
        "saved": "Scenariusz zapisany",
        "to_list": "Powrót do listy",
        "add_detail": "Dodaj scenariusz",
        "edit_detail": "Edytuj scenariusz"
    },
    "notifications": {
        "title": "Powiadomienia",
        "mark_unread": "Oznacz wszystkie jako nieprzeczytane",
        "mark_read": "Oznacz wszystkie jako przeczytane",
        "delete_all": "Usuń wszystkie",
        "no_new": "Brak powiadomień",
        "system": "System",
        "evaluation": {
            "ready": {
                "subject": "Ocena sesji nr :gameNumber",
                "text": "Sesja została oceniona przez eksperta"
            }
        },
        "game": {
            "created": {
                "game_assigned": "Masz przypisaną sesję",
                "role": "Rola:"
            },
            "proposal": {
                "subject": "Koordynacja czasu sesji",
                "time": "Czas:",
                "description": "Potwierdź lub zaproponuj własną opcję"
            },
            "agreed": {
                "subject": "Czas sesji uzgodniony",
                "time": "Czas:",
                "description": "Opis i opcje przygotowania będą dostępne :preparationTime minut przed rozpoczęciem",
                "description_zero": "Możesz teraz zapoznać się z opisem scenariusza i przygotować się"
            },
            "preparation": {
                "subject": "Przygotowanie do sesji",
                "text": "Przygotowanie do sesji jest dostępne."
            },
            "started": {
                "subject": "Sesja nr :gameNumber rozpoczęta",
                "text": "Dołącz!"
            },
            "missed": {
                "subject": "Sesja nr :gameNumber nieobecna",
                "text": "Niestety, nie dotarłeś na sesję"
            },
            "completed": {
                "subject": "Sesja nr :gameNumber ukończona",
                "text": "Sesja zakończona pomyślnie"
            },
            "failed": {
                "subject": "Sesja nr :gameNumber nieudana",
                "text": "Zakończona niepomyślnie"
            },
            "results": {
                "proposed": {
                    "subject": "Protokół sesji nr :gameNumber uzgodniony",
                    "text": "Porozumienie dostępne"
                },
                "declined": {
                    "subject": "Protokół sesji nr :gameNumber odrzucony",
                    "text": "Propozycja odrzucona"
                },
                "not_agreed": {
                    "subject": "Sesja nr :gameNumber: strony nie doszły do porozumienia",
                    "text": "Kapitan przeciwnika odnotował, że strony nie doszły do porozumienia. Sesja zakończyła się niepomyślnie i wyniki nie zostały policzone."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Spotkanie sesji nr :gameNumber zakończone",
                    "text": "Proszę poczekać na wyniki."
                },
                "ended-captain": {
                    "subject": "Spotkanie sesji nr :gameNumber zakończone",
                    "text_fill": "Proszę wypełnić protokół.",
                    "text_wait": "Proszę poczekać na wypełnienie protokołu.",
                    "protocol_time": "Czas protokołu (minuty): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "Dozwolone JPG, GIF lub PNG. Maks. rozmiar 2 MB",
        "avatar_label_choose": "Wybierz",
        "avatar_label_your_avatar": "swój awatar",
        "name": "Imię",
        "last_name": "Nazwisko",
        "patronymic": "Drugie imię",
        "phone": "Telefon",
        "timezone": "Strefa czasowa",
        "language": "Język",
        "country": "Kraj",
        "invalid_phone": "Nieprawidłowy numer telefonu",
        "save_changes": "Zapisz zmiany",
        "account": "Konto",
        "security": "Bezpieczeństwo",
        "statistics": "Statystyki",
        "notifications": "Powiadomienia",
        "change_password_title": "Zmień hasło",
        "change_password": "Zmień hasło",
        "current_password": "Aktualne hasło",
        "new_password": "Nowe hasło",
        "confirm_new_password": "Potwierdź nowe hasło",
        "password_requirements": "Wymagania dotyczące hasła:",
        "password_requirements_1": "Minimum 8 znaków — im więcej, tym lepiej",
        "password_requirements_2": "Co najmniej jedna mała litera",
        "password_requirements_3": "Co najmniej jedna cyfra, symbol lub spacja",
        "two_factor_title": "Uwierzytelnianie dwuskładnikowe",
        "two_factor_description": "Dodaj dodatkową warstwę zabezpieczeń do swojego konta",
        "two_factor_org_enforced": "Uwierzytelnianie dwuskładnikowe jest wymagane przez Twoją organizację",
        "two_factor_method": "Metoda uwierzytelniania",
        "two_factor_disabled": "Wyłączone",
        "two_factor_email": "E-mail",
        "two_factor_sms": "SMS",
        "two_factor_save": "Zapisz ustawienia 2FA"
    },
    "auth": {
        "password": "Hasło",
        "new_password": "Nowe hasło",
        "remember": "Zapamiętaj mnie",
        "timezone": "Strefa czasowa",
        "forgot": "Zapomniałem hasła",
        "login": "Zaloguj się",
        "login_title": "Logowanie",
        "new_password_title": "Zmień hasło",
        "change_password": "Zapisz",
        "country": "Kraj",
        "invalid_phone": "Nieprawidłowy numer telefonu",
        "privacy_policy_title": "Polityka prywatności",
        "privacy_policy_text": "Treść polityki prywatności...",
        "first_time": "Nowy na naszej platformie?",
        "registration": "Utwórz konto",
        "forgot_title": "Zapomniałeś hasła?",
        "forgot_description": "Podaj swój adres e-mail, a wyślemy Ci instrukcje resetowania hasła",
        "send_reset_link": "Wyślij link resetujący ",
        "back_to_login": "Powrót do logowania",
        "register": "Zarejestruj się",
        "name": "Imię",
        "last_name": "Nazwisko",
        "patronymic": "Drugie imię",
        "phone": "Telefon",
        "enter_password": "Wprowadź hasło",
        "confirm_password": "Potwierdź hasło",
        "not_first_time": "Masz już konto?",
        "agree_too": "Zgadzam się na",
        "privacy_policy": "politykę prywatności i warunki",
        "accept": " Akceptuję ",
        "password_validation": "Pole musi zawierać co najmniej jedną wielką literę, małą literę, znak specjalny i cyfrę, a minimalna długość wynosi 8 znaków",
        "password_confirm_error": "Potwierdzenie hasła nie pasuje",
        "set_password": "Ustaw nowe hasło",
        "reset_password": "Resetuj hasło",
        "for": "dla",
        "sign_in_to_for": "Zaloguj się do {app} dla {org}",
        "registration_title": "Rejestracja",
        "verify_title": "Potwierdzenie e-mail",
        "verify_head": "Potwierdź swój e-mail",
        "verify_description": "Link aktywacyjny konta został wysłany na Twój adres e-mail. Kliknij link, aby kontynuować.",
        "verify_new_link": "Nowy link weryfikacyjny został wysłany na adres e-mail podany podczas rejestracji.",
        "verify_send": "Wyślij ponownie e-mail weryfikacyjny",
        "verify_spam": "Przekroczono limit żądań. Spróbuj ponownie za minutę",
        "verify_logout": "Wyloguj się",
        "two_factor_title": "Uwierzytelnianie dwuskładnikowe",
        "two_factor_description_email": "Wysłaliśmy kod weryfikacyjny na Twój adres e-mail. Wprowadź kod poniżej.",
        "two_factor_description_sms": "Wysłaliśmy kod weryfikacyjny na Twój numer telefonu. Wprowadź kod poniżej.",
        "two_factor_code_label": "Kod weryfikacyjny",
        "two_factor_code_placeholder": "Wprowadź 6-cyfrowy kod",
        "two_factor_verify": "Weryfikuj",
        "two_factor_resend": "Wyślij kod ponownie",
        "two_factor_resend_success": "Nowy kod został wysłany",
        "two_factor_back": "Powrót do logowania"
    },
    "filepond": {
        "upload": "Prześlij",
        "upload_complete": "Przesyłanie zakończone",
        "uploading": "Przesyłanie",
        "loading": "Ładowanie",
        "tap_to_cancel": "dotknij, aby anulować",
        "tap_to_undo": "dotknij, aby cofnąć",
        "upload_aborted": "Przesyłanie anulowane",
        "file_too_large": "Plik jest za duży"
    },
    "text-editor": {
        "image": "Po prostu przeciągnij i upuść obraz do edytora"
    },
    "webrtc": {
        "ready_to_start": "Gotowy do startu",
        "connected": "Połączono — możesz mówić!",
        "connection_lost": "Utracono połączenie. Spróbuj ponownie."
    },
    "device_settings": {
        "title": "Ustawienia urządzeń audio i wideo",
        "speaker": "Głośnik/Wyjście audio",
        "refresh_devices": "Odśwież urządzenia",
        "speaker_switch_unsupported": "Przełączanie głośnika nie jest obsługiwane w tej przeglądarce"
    },
    "device_setup": {
        "mic_level": "Poziom mikrofonu",
        "mic_on": "Włączony",
        "mic_off": "Wyłączony",
        "cam_on": "Włączona",
        "cam_off": "Wyłączona"
    },
    "device_test": {
        "title": "Testuj urządzenia audio",
        "speaker_test": "Test głośnika",
        "speaker_hint": "Kliknij przycisk, aby odtworzyć dźwięki testowe przez wybrany głośnik",
        "play_sound": "Odtwórz dźwięk testowy",
        "playing": "Odtwarzanie...",
        "speaker_success": "Dźwięk odtworzony ✓",
        "mic_test": "Test mikrofonu",
        "mic_hint": "Kliknij przycisk i mów do mikrofonu, aby sprawdzić, czy działa",
        "volume_level": "Poziom głośności",
        "speak_now": "Mów teraz...",
        "seconds_short": "s",
        "start_mic_test": "Testuj mikrofon",
        "testing": "Testowanie...",
        "test_again": "Testuj ponownie",
        "mic_success": "Mikrofon działa prawidłowo!",
        "mic_fail": "Wykryto problem z mikrofonem",
        "mic_fail_hint": "Nie wykryto dźwięku. Upewnij się, że mikrofon jest podłączony, niezamknięty i poprawnie wybrany w ustawieniach."
    },
    "ai_assistant_types": {
        "type": "Typ",
        "negotiation": "Negocjacje",
        "feedback": "Informacja zwrotna",
        "ai_profile": "Sesja AI"
    },
    "Login": "Logowanie",
    "UI Elements": "Elementy UI",
    "Forms & Tables": "Formularze i tabele",
    "Welcome": "Witaj",
    "Pages": "Strony",
    "Charts & Maps": "Wykresy i mapy",
    "Others": "Inne",
    "Typography": "Typografia",
    "Cards": "Karty",
    "Basic": "Podstawowe",
    "Advance": "Zaawansowane",
    "Widgets": "Widżety",
    "Components": "Komponenty",
    "Alert": "Alert",
    "Close Alert": "Zamknij alert",
    "Avatar": "Awatar",
    "Badge": "Odznaka",
    "Button": "Przycisk",
    "Calendar": "Kalendarz",
    "Image": "Obraz",
    "Pagination": "Paginacja",
    "Progress Circular": "Postęp kołowy",
    "Progress Linear": "Postęp liniowy",
    "Autocomplete": "Autouzupełnianie",
    "Tooltip": "Podpowiedź",
    "Slider": "Suwak",
    "Date Time Picker": "Wybór daty i godziny",
    "Select": "Wybierz",
    "Switch": "Przełącznik",
    "Checkbox": "Pole wyboru",
    "Radio": "Przycisk opcji",
    "Textarea": "Pole tekstowe",
    "Rating": "Ocena",
    "File Input": "Wejście pliku",
    "Otp Input": "Wejście OTP",
    "Form Layout": "Układ formularza",
    "Form Validation": "Walidacja formularza",
    "Charts": "Wykresy",
    "Apex Chart": "Apex Chart",
    "Chartjs": "Chartjs",
    "Account Settings": "Ustawienia konta",
    "User Profile": "Profil użytkownika",
    "FAQ": "FAQ",
    "Dialog Examples": "Przykłady okien dialogowych",
    "Pricing": "Cennik",
    "List": "Lista",
    "Edit": "Edytuj",
    "Nav Levels": "Poziomy nawigacji",
    "Level 2.1": "Poziom 2.1",
    "Level 2.2": "Poziom 2.2",
    "Level 3.1": "Poziom 3.1",
    "Level 3.2": "Poziom 3.2",
    "Raise Support": "Zgłoś wsparcie",
    "Documentation": "Dokumentacja",
    "Dashboards": "Panele",
    "Analytics": "Analityka",
    "Apps & Pages": "Aplikacje i strony",
    "Email": "E-mail",
    "Chat": "Czat",
    "Invoice": "Faktura",
    "Preview": "Podgląd",
    "Add": "Dodaj",
    "User": "Użytkownik",
    "View": "Wyświetl",
    "Login v1": "Logowanie v1",
    "Login v2": "Logowanie v2",
    "Register v1": "Rejestracja v1",
    "Register v2": "Rejestracja v2",
    "Register": "Rejestracja",
    "Forget Password v1": "Zapomniałem hasła v1",
    "Forget Password v2": "Zapomniałem hasła v2",
    "Forgot Password v1": "Zapomniałem hasła v1",
    "Forgot Password v2": "Zapomniałem hasła v2",
    "Forgot Password": "Zapomniałem hasła",
    "Reset Password v1": "Resetuj hasło v1",
    "Reset Password v2": "Resetuj hasło v2",
    "Reset Password": "Resetuj hasło",
    "Miscellaneous": "Różne",
    "Coming Soon": "Wkrótce dostępne",
    "Not Authorized": "Brak autoryzacji",
    "Under Maintenance": "W trakcie konserwacji",
    "Error": "Błąd",
    "Statistics": "Statystyki",
    "Actions": "Akcje",
    "Access Control": "Kontrola dostępu",
    "User Interface": "Interfejs użytkownika",
    "CRM": "CRM",
    "eCommerce": "eCommerce",
    "Icons": "Ikony",
    "Chip": "Chip",
    "Dialog": "Okno dialogowe",
    "Expansion Panel": "Panel rozwijany",
    "Combobox": "Combobox",
    "Textfield": "Pole tekstowe",
    "Range Slider": "Suwak zakresu",
    "Menu": "Menu",
    "Snackbar": "Snackbar",
    "Tabs": "Zakładki",
    "Form Elements": "Elementy formularza",
    "Form Layouts": "Układy formularzy",
    "Authentication": "Uwierzytelnianie",
    "Page Not Found - 404": "Strona nie znaleziona — 404",
    "Not Authorized - 401": "Brak autoryzacji — 401",
    "Server Error - 500": "Błąd serwera — 500",
    "2": "2",
    "Forms": "Formularze",
    "Timeline": "Oś czasu",
    "Disabled Menu": "Wyłączone menu",
    "Help Center": "Centrum pomocy",
    "Verify Email": "Weryfikuj e-mail",
    "Verify Email v1": "Weryfikuj e-mail v1",
    "Verify Email v2": "Weryfikuj e-mail v2",
    "Two Steps": "Dwa kroki",
    "Two Steps v1": "Dwa kroki v1",
    "Two Steps v2": "Dwa kroki v2",
    "Custom Input": "Niestandardowe wejście",
    "Extensions": "Rozszerzenia",
    "Tour": "Przewodnik",
    "Register Multi-Steps": "Rejestracja wieloetapowa",
    "Wizard Examples": "Przykłady kreatora",
    "Checkout": "Kasa",
    "Create Deal": "Utwórz umowę",
    "Property Listing": "Lista nieruchomości",
    "Roles & Permissions": "Role i uprawnienia",
    "Roles": "Role",
    "Simple Table": "Prosta tabela",
    "Tables": "Tabele",
    "Data Table": "Tabela danych",
    "Permissions": "Uprawnienia",
    "Apps": "Aplikacje",
    "Misc": "Różne",
    "Wizard Pages": "Strony kreatora",
    "Form Wizard": "Kreator formularzy",
    "Numbered": "Numerowane",
    "3": "3",
    "ecommerce": "ecommerce",
    "Ecommerce": "Ecommerce",
    "Editors": "Edytory",
    "Front Pages": "Strony frontowe",
    "Landing": "Landing",
    "checkout": "checkout",
    "Payment": "Płatność",
    "Swiper": "Swiper",
    "Product": "Produkt",
    "Category": "Kategoria",
    "Order": "Zamówienie",
    "Details": "Szczegóły",
    "Customer": "Klient",
    "Manage Review": "Zarządzaj recenzją",
    "Referrals": "Polecenia",
    "Settings": "Ustawienia",
    "Overview": "Przegląd",
    "My Course": "Mój kurs",
    "Course Details": "Szczegóły kursu",
    "Academy": "Akademia",
    "Logistics": "Logistyka",
    "Dashboard": "Panel",
    "Fleet": "Flota",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "maintenance": "Konserwacja",
    "maintenance-page": {
        "title": "Ustawienia konserwacji",
        "notification_section": "Globalne powiadomienie",
        "notification_placeholder": "Wprowadź treść powiadomienia dla wszystkich użytkowników",
        "notification_hint": "Ta wiadomość będzie wyświetlana wszystkim zalogowanym użytkownikom jako ostrzeżenie",
        "games_section": "Blokada sesji",
        "games_blocked_label": "Blokuj nowe sesje",
        "games_blocked_hint": "Gdy włączone, użytkownicy nie mogą tworzyć ani uruchamiać nowych sesji. Do istniejących sesji można ponownie dołączyć.",
        "save": "Zapisz",
        "clear": "Wyczyść",
        "clear_confirm": "Czy na pewno chcesz wyczyścić powiadomienie?",
        "last_updated": "Ostatnia aktualizacja",
        "updated_by": "przez",
        "games_blocked_message": "Przepraszamy za niedogodności. Platforma jest obecnie w trakcie konserwacji. Sesje są tymczasowo niedostępne."
    },
    "$vuetify": {
        "badge": "Odznaka",
        "noDataText": "Brak dostępnych danych",
        "close": "Zamknij",
        "open": "otwórz",
        "carousel": {
            "ariaLabel": {
                "delimiter": "delimiter"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "Elementów na stronę:",
            "itemsPerPageAll": "Wszystkie",
            "pageText": "{0}–{1} z {2}",
            "firstPage": "Pierwsza strona",
            "prevPage": "Poprzednia strona",
            "nextPage": "Następna strona",
            "lastPage": "Ostatnia strona"
        },
        "pagination": {
            "ariaLabel": {
                "root": "root",
                "previous": "previous",
                "next": "next",
                "first": "first",
                "last": "last",
                "currentPage": "currentPage",
                "page": "page"
            }
        },
        "input": {
            "clear": "clear",
            "appendAction": "appendAction",
            "prependAction": "prependAction",
            "counterSize": "counterSize",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "counterSize"
        },
        "rating": {
            "ariaLabel": {
                "item": "item"
            }
        }
    },
    "subscription-plans": "Plany subskrypcji",
    "organization-subscriptions": "Subskrypcje organizacji",
    "subscription-plans-page": {
        "name": "Nazwa",
        "description": "Opis",
        "period": "Okres",
        "grace_days": "Dni karencji",
        "features": "Funkcje",
        "charges": "Opłaty",
        "actions": " ",
        "add": "Dodaj plan",
        "add_popup": "Dodaj plan",
        "edit": "Edytuj plan",
        "edit_popup": "Edytuj plan",
        "delete": "Usuń plan",
        "delete_confirm": "Czy na pewno chcesz usunąć ten plan?",
        "monthly": "Miesięczny",
        "yearly": "Roczny",
        "permanent": "Stały",
        "regular_games": "Regularne sesje",
        "ai_games": "Sesje AI",
        "any_games": "Dowolne sesje",
        "ai_chat_messages": "Wiadomości czatu AI",
        "organization": "Organizacja",
        "global_plan": "Globalny",
        "periodicity": "Okresowość",
        "min_zero": "Musi być >= 0",
        "min_one": "Musi być >= 1"
    },
    "organization-subscriptions-page": {
        "organization": "Organizacja",
        "host": "Host",
        "current_plan": "Aktualny plan",
        "status": "Status",
        "expires_at": "Wygasa",
        "actions": " ",
        "assign_plan": "Przypisz plan",
        "switch_plan": "Zmień plan",
        "cancel_subscription": "Anuluj subskrypcję",
        "renew_subscription": "Odnów subskrypcję",
        "cancel_confirm": "Czy na pewno chcesz anulować tę subskrypcję?",
        "renew_confirm": "Czy na pewno chcesz odnowić tę subskrypcję?",
        "no_plan": "Brak planu",
        "active": "Aktywna",
        "cancelled": "Anulowana",
        "expired": "Wygasła",
        "immediately": "Zmień natychmiast",
        "view_usage": "Wyświetl użycie",
        "usage": "Użycie",
        "used_of": "{used} z {limit}",
        "add_ticket": "Dodaj pakiet",
        "initial_consumption": "Zużycie początkowe",
        "feature": "Funkcja",
        "charges": "Opłaty",
        "expired_at_optional": "Data wygaśnięcia (opcjonalna)",
        "active_tickets": "Aktywne pakiety",
        "no_expiry": "Bez wygaśnięcia",
        "tickets_only": "Pakiety",
        "revoke_ticket": "Odwołaj",
        "revoke_ticket_confirm": "Czy na pewno chcesz odwołać ten pakiet?",
        "deduct": "Odejmij",
        "deduct_amount": "Kwota",
        "deduct_confirm": "Odejmij użycie"
    },
    "api-tokens": "Tokeny API",
    "api-tokens-page": {
        "select_user": "Użytkownik",
        "select_user_hint": "Wybierz użytkownika, aby wyświetlić jego tokeny API i zarządzać nimi.",
        "no_users_found": "Nie znaleziono użytkowników",
        "no_tokens": "Ten użytkownik nie ma tokenów API.",
        "token_name": "Nazwa",
        "abilities": "Uprawnienia",
        "ability": "Uprawnienie",
        "created_at": "Data utworzenia",
        "last_used_at": "Ostatnio użyto",
        "expires_at": "Wygasa",
        "actions": " ",
        "issue_token": "Wystaw token",
        "issue": "Wystaw",
        "issue_failed": "Nie udało się wystawić tokenu",
        "token": "Token",
        "plaintext_warning": "Skopiuj ten token teraz — nie zostanie on ponownie wyświetlony.",
        "revoke": "Unieważnij",
        "revoke_confirm": "Czy na pewno chcesz unieważnić ten token? Integracje, które z niego korzystają, przestaną działać."
    },
    "subscription": {
        "current_plan": "Aktualny plan",
        "expires_at": "Wygasa: {date}",
        "no_active_plan": "Brak aktywnego planu subskrypcji",
        "quota_warning": "Mało pozostałego limitu",
        "regular_games": "Regularne sesje",
        "ai_games": "Sesje AI",
        "any_games": "Dowolne sesje",
        "ai_chat_messages": "Wiadomości czatu AI",
        "used_of": "{used} z {limit}",
        "remaining": "Pozostało: {count}",
        "quota_exceeded": "Przekroczono limit funkcji",
        "tickets_only": "Pakiety kredytów",
        "session_package": "Pakiet sesji",
        "games_available": "Sesje",
        "users": "Użytkownicy",
        "active_users": "Aktywni użytkownicy",
        "active_tickets": "Pakiety kredytów",
        "ticket_charges": "{charges} kredytów",
        "ticket_no_expiry": "Bez wygaśnięcia",
        "unlimited": "Nieograniczone",
        "no_game_limits": "Brak ograniczeń dotyczących liczby sesji"
    },
    "knowledge-base-page": {
        "title": "Baza wiedzy",
        "upload": "Prześlij dokument",
        "search-placeholder": "Szukaj według tytułu...",
        "filter-status": "Status",
        "confirm-delete": "Czy na pewno chcesz usunąć ten dokument? Wszystkie powiązane fragmenty zostaną usunięte.",
        "no-documents": "Brak dostępnych dokumentów",
        "status": {
            "processing": "Przetwarzanie",
            "ready": "Gotowy",
            "failed": "Błąd"
        },
        "headers": {
            "title": "Tytuł",
            "type": "Typ",
            "size": "Rozmiar",
            "chunks": "Fragmenty",
            "status": "Status",
            "created": "Data przesłania",
            "actions": "Akcje"
        },
        "upload-dialog": {
            "title": "Prześlij dokument",
            "name": "Tytuł",
            "file": "Plik",
            "hint": "PDF, DOCX, TXT, CSV, XLSX (maks. 10 MB)",
            "submit": "Prześlij"
        },
        "retry-success": "Dokument wysłany do ponownego przetworzenia",
        "delete-success": "Dokument usunięty",
        "upload-success": "Dokument przesłany",
        "provider-unsupported": "Baza wiedzy jest niedostępna dla obecnego dostawcy AI Twojej organizacji."
    },
    "candidate-page": {
        "document_title": "Rozmowa kwalifikacyjna",
        "greeting": "Dzień dobry, {name}!",
        "intro_lead": "{organization} zaprasza na rozmowę kwalifikacyjną z wirtualnym rozmówcą na stanowisko „{vacancy}”.",
        "duration": "Rozmowa zajmie około {minutes} min.",
        "requirements_title": "Co będzie potrzebne",
        "requirement_mic": "Sprawny mikrofon, najlepiej słuchawki z mikrofonem",
        "requirement_camera_required": "Włączona kamera: jest wymagana podczas tej rozmowy",
        "requirement_camera_optional": "Kamera nie jest wymagana, ale z nią rozmowa przebiega bardziej naturalnie",
        "requirement_browser": "Komputer z aktualną wersją przeglądarki Chrome, Edge lub Safari",
        "requirement_network": "Stabilne połączenie internetowe i ciche miejsce bez zakłóceń",
        "continue": "Kontynuuj",
        "consent": {
            "accept": "Zapoznałem/-am się z treścią i wyrażam zgodę na przetwarzanie moich danych osobowych",
            "back": "Wstecz",
            "start": "Rozpocznij rozmowę"
        },
        "terminal": {
            "finished": {
                "title": "Dziękujemy!",
                "text": "Rozmowa dobiegła końca, a jej wynik trafił już do rekrutera, który wkrótce się odezwie. Tę stronę można już zamknąć."
            },
            "already_completed": {
                "title": "Rozmowa została już przeprowadzona",
                "text": "Ten link posłużył już do ukończonej rozmowy kwalifikacyjnej. Jeśli konieczne jest jej powtórzenie, proszę skontaktować się z rekruterem."
            },
            "not_found": {
                "title": "Nie znaleziono linku",
                "text": "Adres mógł zostać wpisany niepoprawnie albo link przestał być aktywny. Proszę sprawdzić e-mail od rekrutera lub skontaktować się z nim."
            },
            "session_conflict": {
                "title": "Zalogowano na inne konto",
                "text": "Proszę wylogować się z bieżącego konta lub otworzyć link w oknie prywatnym przeglądarki."
            },
            "link_revoked": {
                "title": "Dostęp do tego linku został zablokowany",
                "text": "Rekruter odwołał ten link. Aby otrzymać nowy, proszę się z nim skontaktować."
            },
            "link_expired": {
                "title": "Link wygasł",
                "text": "Proszę skontaktować się z rekruterem, aby wydał nowy link."
            },
            "attempts_exhausted": {
                "title": "Brak dostępnych prób",
                "text": "Wszystkie próby dostępne w ramach tego linku zostały wykorzystane. Proszę skontaktować się z rekruterem."
            },
            "unavailable": {
                "title": "Nie można teraz rozpocząć",
                "text": "Proszę spróbować później lub skontaktować się z rekruterem."
            },
            "rate_limited": {
                "title": "Zbyt wiele prób",
                "text": "Proszę odczekać minutę i odświeżyć stronę."
            },
            "aborted": {
                "title": "Rozmowa się nie rozpoczęła",
                "text": "Proszę odświeżyć stronę i spróbować ponownie. Jeśli to nie pomoże, proszę skontaktować się z rekruterem."
            },
            "generic": {
                "title": "Coś poszło nie tak",
                "text": "Proszę odświeżyć stronę i spróbować ponownie. Jeśli to nie pomoże, proszę skontaktować się z rekruterem."
            }
        }
    },
    "recruiting-page": {
        "title": "Rekrutacja",
        "create": "Nowa oferta",
        "edit": "Edytuj ofertę",
        "empty": "Brak ofert",
        "load_error": "Nie udało się wczytać listy ofert",
        "retry": "Spróbuj ponownie",
        "back": "Do listy ofert",
        "open": "Kandydaci",
        "archive": "Archiwizuj",
        "no_expiry": "Bez wygaśnięcia",
        "confirm_archive": "Zarchiwizować tę ofertę? Nie będzie już można wydawać dla niej linków.",
        "headers": {
            "title": "Oferta",
            "scenario": "Scenariusz",
            "status": "Status",
            "expires_at": "Wygasa",
            "actions": "Akcje"
        },
        "status": {
            "draft": "Szkic",
            "active": "Aktywna",
            "archived": "Zarchiwizowana"
        },
        "dialog": {
            "title_label": "Tytuł oferty",
            "scenario_label": "Scenariusz rozmowy",
            "scenario_placeholder": "Wybierz scenariusz rozmowy z AI",
            "scenario_hint": "Widoczne są wyłącznie scenariusze odpowiednie do gry z AI",
            "status_label": "Status",
            "expires_label": "Ważna do",
            "expires_hint": "Puste = brak terminu",
            "save": "Zapisz",
            "cancel": "Anuluj"
        },
        "messages": {
            "created": "Oferta utworzona",
            "updated": "Oferta zaktualizowana",
            "archived": "Oferta zarchiwizowana",
            "revoked": "Link odwołany",
            "attempt_granted": "Kandydatowi przyznano dodatkową próbę",
            "copied": "Link skopiowany",
            "error": "Coś poszło nie tak"
        },
        "candidates": {
            "title": "Kandydaci",
            "empty": "Brak wydanych linków dla tej oferty",
            "load_error": "Nie udało się wczytać listy kandydatów",
            "issue": "Wydaj link",
            "import": "Importuj z pliku",
            "expired": "Wygasły",
            "no_games": "Rozmowa nie rozpoczęta",
            "attempts": "{used} z {allowed}",
            "revoke": "Odwołaj link",
            "extra_attempt": "Przyznaj dodatkową próbę",
            "open_result": "Otwórz wynik rozmowy",
            "confirm_revoke": "Odwołać link kandydata? Dostęp zostanie natychmiast utracony, również do trwającej rozmowy.",
            "confirm_extra_attempt": "Przyznać kandydatowi dodatkową próbę?",
            "headers": {
                "candidate": "Kandydat",
                "link_status": "Link",
                "invite": "Zaproszenie",
                "game_status": "Rozmowa",
                "attempts": "Próby",
                "expires_at": "Wygasa",
                "actions": "Akcje"
            },
            "link_status": {
                "created": "Wydany",
                "opened": "Otwarty",
                "in_progress": "Trwa rozmowa",
                "completed": "Rozmowa zakończona",
                "revoked": "Odwołany"
            },
            "invite_status": {
                "not_sent": "Nie wysłano",
                "queued": "W kolejce",
                "sent": "Wysłano",
                "failed": "Nie udało się wysłać"
            },
            "invite_sent_at": "Serwis pocztowy przyjął wiadomość: {date}",
            "invite_failure": {
                "rejected": "Serwis pocztowy odrzucił wiadomość — wyślij link kandydatowi samodzielnie",
                "transport": "Wysyłka nie powiodła się — wyślij link kandydatowi samodzielnie",
                "revoked": "Link został odwołany",
                "sending_disabled": "Wysyłanie wiadomości e-mail jest wyłączone",
                "blocked": "Adres jest na liście blokad — wyślij link kandydatowi samodzielnie"
            }
        },
        "issue_dialog": {
            "title": "Wydaj indywidualny link",
            "name": "Imię",
            "last_name": "Nazwisko",
            "email": "E-mail",
            "phone": "Telefon",
            "attempts": "Liczba prób",
            "expires_at": "Link ważny do",
            "expires_hint": "Puste = termin zostanie przejęty z oferty",
            "submit": "Wydaj link",
            "close": "Zamknij",
            "result_title": "Link wydany",
            "warning": "Skopiuj link teraz — jest wyświetlany tylko raz. W bazie przechowywany jest wyłącznie jego hash, więc nie można go odzyskać: utracony link trzeba odwołać i wydać nowy.",
            "copy": "Kopiuj",
            "copied": "Skopiowano",
            "send_invite": "Wyślij zaproszenie na adres {email}",
            "send_invite_no_email": "Wyślij zaproszenie e-mailem",
            "send_invite_blocked": "Ten adres jest na liście blokad — wiadomość nie zostanie wysłana",
            "invite_queued": "Zaproszenie na adres {email} dodano do kolejki",
            "invite_blocked": "Zaproszenie nie zostało wysłane: adres {email} jest na liście blokad. Wyślij link kandydatowi samodzielnie"
        },
        "import_dialog": {
            "title": "Import kandydatów",
            "subtitle": "Każdy wiersz pliku to jeden kandydat i jeden indywidualny link.",
            "file": "Plik z listą kandydatów",
            "columns": "Kolumny: Imię, Nazwisko, E-mail, Telefon",
            "limits": "xlsx lub CSV (średnik), do 200 wierszy i 10 MB",
            "size_error": "Plik jest większy niż 10 MB",
            "download_example": "Pobierz szablon",
            "note_title": "Linki widoczne tylko w pobranym pliku",
            "note_text": "Plik pobierze się automatycznie zaraz po zakończeniu importu. W bazie przechowywane są wyłącznie hashe linków, więc nie da się pobrać ich ponownie — zachowaj ten plik.",
            "submit": "Importuj",
            "cancel": "Anuluj",
            "result_title": "Linki wydane",
            "result": "Wydano linków: {count}. Plik został pobrany.",
            "invites_blocked": "Niewysłane zaproszenia: {count}. Te adresy są na liście blokad — wyślij linki tym kandydatom samodzielnie.",
            "saved_title": "Zachowaj pobrany plik",
            "saved_text": "To jedyna kopia tych linków: baza przechowuje tylko ich hashe. Utracony link można wyłącznie odwołać i wydać nowy.",
            "download_again": "Pobierz plik ponownie",
            "errors_title": "Odrzucone wiersze",
            "error_row": "Wiersz {row}: {error}",
            "errors_truncated": "…i jeszcze {count} odrzuconych wierszy. Powyżej pokazano pierwsze 50.",
            "send_invites": "Wyślij kandydatom zaproszenia e-mailem",
            "send_invites_hint": "Kandydaci bez adresu e-mail nie otrzymają wiadomości"
        }
    },
    "ai-reports": "Raporty AI",
    "ai-reports-page": {
        "title": "Raporty AI",
        "subtitle": "Opisz raport własnymi słowami — zbudujemy specyfikację, pokażemy podgląd i wyeksportujemy do Excela.",
        "status": {
            "draft": "Szkic",
            "pending": "W trakcie generowania",
            "ready": "Gotowy",
            "failed": "Nie udało się wygenerować"
        },
        "list": {
            "title": "Moje raporty",
            "new": "Nowy raport",
            "empty": "Nie ma jeszcze żadnych raportów. Kliknij „Nowy raport” i opisz, co pokazać.",
            "untitled": "Bez nazwy",
            "delete": "Usuń raport",
            "delete_confirm": "Usunąć raport razem z wygenerowanym plikiem?",
            "deleted": "Raport usunięty"
        },
        "dialog": {
            "title": "Dialog",
            "open_dictionary": "Słownik danych",
            "placeholder": "Na przykład: ile gier przeprowadził każdy dział w ostatnim kwartale",
            "send": "Wyślij",
            "empty_title": "Co ma pokazywać raport?",
            "empty_text": "Napisz zwykłymi słowami: jakie dane, za jaki okres i w jakim podziale. Jeśli czegoś zabraknie, dopytam.",
            "examples_title": "Na przykład:",
            "examples": {
                "e1": "Ile gier przeprowadził każdy dział w ostatnim kwartale",
                "e2": "Średni wynik kompetencji w dziale sprzedaży za 2026 rok",
                "e3": "Pracownicy, którzy nie grali od ponad miesiąca",
                "e4": "Kandydaci według ofert pracy i statusów ich linków z ostatnich 30 dni"
            },
            "thinking": "Generowanie raportu…",
            "waiting_hint": "Odpowiedź pojawi się tutaj sama — nie trzeba odświeżać strony.",
            "retry": "Spróbuj ponownie",
            "dismiss": "Ukryj",
            "spec_ready": "Raport został zbudowany — sprawdź podgląd poniżej i wygeneruj plik.",
            "stuck_title": "Wygląda na to, że kręcimy się w kółko",
            "stuck_text": "Zajrzyj do słownika danych i przeformułuj zapytanie jego słowami — to szybsze niż odpowiadanie na kolejne pytanie doprecyzowujące.",
            "rejected_title": "Tego raportu jeszcze nie da się wygenerować",
            "reason": {
                "no_such_measure": "Takiej miary nie ma w naszych danych. Sprawdź listę miar w słowniku.",
                "no_such_field": "Takiego pola nie ma w naszych danych. Sprawdź listę pól w słowniku.",
                "cross_dataset": "Zapytanie wymaga danych jednocześnie z dwóch zestawów danych. Podziel je na dwa raporty.",
                "window_function": "Udziały w sumie, pozycje w rankingu i porównanie z poprzednim okresem nie są jeszcze obsługiwane.",
                "other": "Zapytanie wykracza poza dostępne dane. Sprawdź słownik i spróbuj innego sformułowania."
            },
            "usage": {
                "employees": "brak pracowników | {n} pracownik | pracowników: {n}",
                "games": "brak gier | {n} gra | gier: {n}",
                "scenarios": "brak scenariuszy | {n} scenariusz | scenariuszy: {n}",
                "evaluations": "brak ocen | {n} ocena | ocen: {n}",
                "candidates": "brak kandydatów | {n} kandydat | kandydatów: {n}"
            },
            "option_created_at": "dodano {date}"
        },
        "preview": {
            "title": "Podgląd",
            "no_report": "Wybierz raport po lewej stronie lub rozpocznij nowy.",
            "no_spec": "Opisz raport w dialogu — podgląd pojawi się, gdy tylko zapytanie zostanie zrozumiane.",
            "spec_title": "Co będzie zawierał raport",
            "rows_hint": "Pokazano pierwsze {count} wierszy",
            "total": "Liczba wierszy łącznie: {count}",
            "zero_rows": "To zapytanie nie zwraca ani jednego wiersza. Rozszerz okres lub usuń filtry — nie ma sensu generować pustego pliku.",
            "zero_rows_hint": "Sprawdź wartości filtrów — może dla nich nie być danych",
            "duplicate_rows": "Niektóre wiersze podglądu są identyczne: wybrane kolumny nie odróżniają rekordów tego zestawu danych. Sprawdź, co tak naprawdę oznacza tu jeden wiersz — może brakować kolumny, która je rozróżnia.",
            "too_many_rows": "Raport zawiera {count} wierszy, maksimum to {max}. Zawęź okres lub dodaj filtry: po przekroczeniu limitu plik w ogóle nie jest generowany, a nie obcinany.",
            "generate": "Wygeneruj plik",
            "regenerate": "Wygeneruj ponownie",
            "queued": "Plik jest generowany — karta zaktualizuje się sama, gdy będzie gotowy.",
            "failed": "Nie udało się wygenerować raportu",
            "download": "Pobierz .xlsx",
            "downloads": "Liczba pobrań: {count}",
            "ttl_warning": "Plik jest przechowywany przez {days} dni, a potem usuwany — pobierz go od razu.",
            "expires_at": "Dostępny do {date}",
            "expired": "Plik został usunięty po upływie okresu przechowywania — wygeneruj raport ponownie."
        },
        "spec": {
            "dataset": "Dane",
            "columns": "Kolumny",
            "measures": "Miary",
            "group_by": "Podział",
            "period": "Okres",
            "period_value": "{field}: od {from} do {to}",
            "period_all": "Cały dostępny okres",
            "filters": "Filtry",
            "having": "Warunki dla miar",
            "sort": "Sortowanie",
            "limit": "Limit wierszy",
            "limit_value": "pierwsze {count} wierszy",
            "granularity": {
                "year": "według roku",
                "quarter": "według kwartału",
                "month": "według miesiąca",
                "week": "według tygodnia",
                "day": "według dnia",
                "dow": "według dnia tygodnia"
            },
            "dir": {
                "asc": "rosnąco",
                "desc": "malejąco"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — różne od {value}",
                "in": "{field} — jedno z: {value}",
                "not_in": "{field} — z wyjątkiem: {value}",
                "gt": "{field} większe niż {value}",
                "gte": "{field} co najmniej {value}",
                "lt": "{field} mniejsze niż {value}",
                "lte": "{field} co najwyżej {value}",
                "contains": "{field} zawiera „{value}”",
                "between": "{field} — od {from} do {to}",
                "is_null": "{field} nie jest wypełnione",
                "is_not_null": "{field} jest wypełnione"
            }
        },
        "value": {
            "yes": "Tak",
            "no": "Nie"
        },
        "dictionary": {
            "title": "Słownik danych",
            "subtitle": "Wszystko, co można umieścić w raporcie. Lista jest aktualna na żywo: to ta sama lista, na podstawie której budowana jest specyfikacja.",
            "fields": "Pola",
            "measures": "Miary",
            "values": "Wartości",
            "show_values": "Pokaż wartości swojej organizacji",
            "hide_values": "Ukryj wartości",
            "values_error": "Nie udało się wczytać wartości — spróbuj ponownie.",
            "values_empty": "Twoja organizacja nie ma jeszcze żadnych wartości dla tego pola.",
            "limits": {
                "title": "Czego raport nie potrafi",
                "pivot": "Tabela przestawna z kolumną dla każdego uczestnika lub dla każdego pytania nie powstanie. Zamów zamiast tego długą formę: wiersz dla każdej pary uczestnik–pytanie.",
                "window": "Raport nie liczy zmiany miesiąc do miesiąca, udziału w sumie, pozycji w rankingu ani „trzech najlepszych w każdym dziale”. Weź podział na miesiące i dolicz resztę w Excelu.",
                "missing": "Czego system nie przechowuje, tego nie będzie w raporcie: wynagrodzenia, NPS i inne dane z innych systemów nie pojawią się pod żadną nazwą."
            },
            "empty": "Słownik jest pusty — skontaktuj się z administratorem.",
            "close": "Zamknij"
        },
        "errors": {
            "generic": "Coś poszło nie tak. Spróbuj ponownie.",
            "detail": "Nie zrozumiano: {value}",
            "rate_limit": "Zbyt wiele żądań. Poczekaj minutę i spróbuj ponownie.",
            "download": "Nie udało się pobrać pliku.",
            "turn_failed": "Nie udało się uzyskać odpowiedzi. Wyślij zapytanie ponownie.",
            "turn_stuck_in_queue": "Zapytanie nie trafiło do przetwarzania — zbyt długo czekało w kolejce. Wyślij je ponownie.",
            "unknown_resolution": "Ta opcja jest nieaktualna — raport w międzyczasie się zmienił. Otwórz go ponownie i doprecyzuj zapytanie."
        }
    },
    "externalLaunch": {
        "document_title": "Trening",
        "intro": {
            "title": "Rozmowa treningowa",
            "lead": "Zaraz porozmawiasz z wirtualnym rozmówcą. Rozmowa jest nagrywana i oceniana, a wynik trafi do Twojego systemu szkoleniowego.",
            "requirements_title": "Czego będziesz potrzebować",
            "requirement_mic": "Sprawnego mikrofonu, najlepiej zestawu słuchawkowego",
            "requirement_camera": "Kamera nie jest obowiązkowa, ale z nią rozmowa wypada bardziej naturalnie",
            "requirement_browser": "Komputera z aktualną wersją Chrome, Edge lub Safari",
            "requirement_network": "Stabilnego łącza i cichego miejsca, w którym nikt Ci nie przeszkodzi",
            "start": "Rozpocznij"
        },
        "relaunch_hint": "Wróć do swojego systemu szkoleniowego i otwórz materiał ponownie.",
        "saving": "Zapisujemy wynik…",
        "review": {
            "document_title": "Podsumowanie sesji",
            "attempt": "Próba {number}",
            "result": {
                "passed": "Zaliczone",
                "failed": "Niezaliczone",
                "pending": "Ocena jeszcze niegotowa"
            },
            "score_of_100": "{score} na 100",
            "threshold": "Próg zaliczenia: {threshold}",
            "skills_title": "Umiejętności i rekomendacje",
            "skills_empty": "Dla tej próby nie ma jeszcze rozbioru poszczególnych umiejętności.",
            "comments_title": "Komentarze do nagrania",
            "comments_empty": "Do tego nagrania nie ma komentarzy.",
            "loading": "Wczytywanie podsumowania",
            "error": {
                "not_found": {
                    "title": "Link nie działa",
                    "text": "Podsumowanie nie jest już dostępne: link wygasł albo próba została odwołana."
                },
                "expired": {
                    "title": "Strona wygasła",
                    "text": "Otwórz podsumowanie ponownie z linku w systemie szkoleniowym."
                },
                "generic": {
                    "title": "Nie udało się wyświetlić podsumowania",
                    "text": "Coś poszło nie tak po naszej stronie. Spróbuj otworzyć link jeszcze raz."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Dziękujemy!",
                "text": "Rozmowa zakończona. Wynik pojawi się w Twoim systemie szkoleniowym, gdy tylko ocena będzie gotowa. Tę stronę możesz zamknąć."
            },
            "aborted": {
                "title": "Rozmowa się nie rozpoczęła",
                "text": "Coś poszło nie tak, zanim rozmowa się zaczęła."
            },
            "token_expired": {
                "title": "Sesja wygasła",
                "text": "Dostęp do tej rozmowy już nie obowiązuje."
            },
            "not_found": {
                "title": "Link nie działa",
                "text": "W adresie mógł wkraść się błąd albo link już nie jest ważny."
            },
            "rate_limited": {
                "title": "Zbyt wiele prób",
                "text": "Odczekaj minutę, zanim spróbujesz ponownie."
            },
            "generic": {
                "title": "Nie można teraz rozpocząć",
                "text": "Coś poszło nie tak po naszej stronie."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Materiał jest zamknięty",
                "text": "Ten materiał nie jest już dostępny do ćwiczenia."
            },
            "publication_draft": {
                "title": "Materiał nie został jeszcze opublikowany",
                "text": "Ćwiczeń z tego materiału jeszcze nie otwarto."
            },
            "publication_expired": {
                "title": "Termin materiału minął",
                "text": "Czas, w którym można było ćwiczyć ten materiał, dobiegł końca."
            },
            "feature_disabled": {
                "title": "Materiał jest zamknięty",
                "text": "Ćwiczenie z systemu szkoleniowego jest wyłączone w Twojej organizacji."
            },
            "connection_disabled": {
                "title": "Materiał jest zamknięty",
                "text": "Połączenie z Twoim systemem szkoleniowym jest wyłączone. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "launch_limit_reached": {
                "title": "Limit został osiągnięty",
                "text": "Dla tego materiału przeprowadzono już maksymalną liczbę rozmów."
            },
            "daily_budget_exhausted": {
                "title": "Na dziś wystarczy",
                "text": "Wykorzystano liczbę rozmów dozwoloną na dziś. Spróbuj ponownie jutro."
            },
            "attempts_exhausted": {
                "title": "Nie zostały już żadne próby",
                "text": "Wykorzystano wszystkie próby dozwolone dla tego materiału."
            },
            "quota_exhausted": {
                "title": "Nie można teraz rozpocząć",
                "text": "Twoja organizacja nie ma już dostępnych rozmów. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "user_limit_reached": {
                "title": "Nie można teraz rozpocząć",
                "text": "W Twojej organizacji nie ma już wolnych miejsc. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "scenario_unavailable": {
                "title": "Materiał jest niedostępny",
                "text": "Rozmowy, na której oparty jest ten materiał, już nie ma."
            },
            "assignment_check_unavailable": {
                "title": "Nie można teraz rozpocząć",
                "text": "Nie udało się potwierdzić, że ten materiał jest przypisany właśnie Tobie. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "code_invalid": {
                "title": "Link już nie jest ważny",
                "text": "Ten link został już użyty albo jego czas się skończył."
            },
            "channel_verification_failed": {
                "title": "System szkoleniowy nie odpowiedział",
                "text": "Nie udało się potwierdzić żądania w Twoim systemie szkoleniowym."
            },
            "external_system_unavailable": {
                "title": "System szkoleniowy nie odpowiada",
                "text": "Nie udało się sprawdzić przypisania kursu w systemie szkoleniowym. Spróbuj ponownie za kilka minut."
            },
            "user_not_found": {
                "title": "Nie udało się Cię zidentyfikować",
                "text": "Nie ma tu dla Ciebie konta, a Twoja organizacja nie tworzy ich automatycznie. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "user_unavailable": {
                "title": "Twoje konto jest wyłączone",
                "text": "Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "user_deleted": {
                "title": "Twoje konto zostało usunięte",
                "text": "Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "email_taken_linking_disabled": {
                "title": "Nie udało się Cię zidentyfikować",
                "text": "Twój adres e-mail należy już do innego konta. Skontaktuj się z osobą, która przydzieliła kurs."
            },
            "service_role_not_allowed": {
                "title": "To konto nie może ćwiczyć",
                "text": "Konta administracyjne nie biorą udziału w rozmowach treningowych. Zaloguj się na swoje konto uczestnika."
            },
            "unverified_request": {
                "title": "Nie udało się potwierdzić żądania",
                "text": "Twój system szkoleniowy nie potwierdził, że tę rozmowę rozpoczęto z Twojego konta."
            }
        },
        "manage": {
            "nav": {
                "group": "Zewnętrzne uruchamianie",
                "publications": "Publikacje",
                "connections": "Połączenia LMS"
            },
            "messages": {
                "error": "Coś poszło nie tak. Spróbuj ponownie.",
                "load_error": "Nie udało się wczytać danych."
            },
            "connections": {
                "title": "Połączenia z systemami szkoleniowymi",
                "subtitle": "Konta systemów szkoleniowych, z których ta organizacja uruchamia ćwiczenia.",
                "create": "Dodaj połączenie",
                "edit": "Edytuj",
                "set_credentials": "Ustaw dane dostępowe",
                "empty": "Nie ma jeszcze żadnych połączeń.",
                "secret_missing": "Nie ustawiono",
                "no_expiry": "Nie wygasa",
                "headers": {
                    "account": "Konto",
                    "base_url": "Adres",
                    "client_id": "Identyfikator klienta",
                    "secret": "Sekret",
                    "status": "Status",
                    "expires_at": "Dane dostępowe wygasają",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Brak danych dostępowych",
                    "active": "Aktywne",
                    "expired": "Dane dostępowe wygasły",
                    "disabled": "Wyłączone"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nowe połączenie",
                    "edit_title": "Połączenie",
                    "immutable_hint": "Systemu szkoleniowego i konta nie można zmienić: określają przestrzeń tożsamości uczestnika. Inne konto to nowe połączenie.",
                    "lms_label": "System szkoleniowy",
                    "account_key_label": "Konto",
                    "account_key_hint": "Identyfikator konta w systemie szkoleniowym.",
                    "base_url_label": "Adres REST API iSpring",
                    "base_url_hint": "Na przykład https://api-learn.ispringlearn.ru. To nie adres portalu firmy: na niego zostanie wysłany sekret.",
                    "base_url_https": "Adres musi zaczynać się od https://",
                    "enabled_label": "Połączenie jest włączone",
                    "enabled_hint": "Połączenia nigdy się nie usuwa — wyłącza się je. Publikacje i uruchomienia pozostają na listach, ale nowe uruchomienia są odrzucane, a wyniki nie trafiają już do systemu szkoleniowego.",
                    "credentials_optional": "Dane dostępowe są opcjonalne. Bez nich połączenie działa w trybie ograniczonym.",
                    "client_id_label": "Identyfikator klienta",
                    "secret_label": "Sekret",
                    "secret_hint": "Przechowywany w postaci zaszyfrowanej. Nie można go odczytać ponownie — widoczne są tylko cztery ostatnie znaki.",
                    "expires_at_label": "Dane dostępowe wygasają",
                    "expires_at_hint": "Zostaw puste, jeśli dane dostępowe nie wygasają."
                },
                "credentials_dialog": {
                    "title": "Dane dostępowe",
                    "lead": "Nowy sekret zastępuje poprzedni. Połączenie zachowuje swój identyfikator, a linki uczestników i uruchomienia pozostają na miejscu.",
                    "secret_hint": "Poprzedni sekret nie jest potrzebny i nie można go odczytać ponownie."
                },
                "messages": {
                    "saved": "Połączenie zapisane",
                    "credentials_saved": "Dane dostępowe zapisane"
                }
            },
            "publications": {
                "title": "Publikacje",
                "subtitle": "Scenariusze otwarte do uruchamiania z systemu szkoleniowego.",
                "create": "Nowa publikacja",
                "edit": "Edytuj",
                "enable": "Włącz",
                "disable": "Wyłącz",
                "open_journal": "Dziennik",
                "download_package": "Pobierz pakiet",
                "empty": "Nie ma jeszcze żadnych publikacji.",
                "no_connections": "Nie ma jeszcze połączenia z systemem szkoleniowym. Zakłada je administrator platformy.",
                "no_expiry": "Bez terminu",
                "attempts_unlimited": "Bez ograniczenia",
                "immutable_hint": "Połączenia, scenariusza i kanału dostarczania nie można zmienić: są wbudowane w pakiet już przesłany do systemu szkoleniowego. Wszystko inne stosuje się bez jego przebudowy.",
                "headers": {
                    "scenario": "Scenariusz",
                    "connection": "Połączenie",
                    "channel": "Kanał",
                    "status": "Status",
                    "settings": "Ustawienia",
                    "expires_at": "Wygasa",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Próby: {value}",
                    "threshold": "Próg zaliczenia: {value}"
                },
                "status": {
                    "draft": "Szkic",
                    "active": "Aktywna",
                    "disabled": "Wyłączona"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Tylko status",
                    "status_and_score": "Status i wynik",
                    "status_score_and_review": "Status, wynik i link do podsumowania"
                },
                "warnings": {
                    "limited_mode": "Tryb ograniczony: wynik i status nie pojawią się w systemie szkoleniowym, a sprawdzanie przypisania nie jest wykonywane.",
                    "connection_disabled": "Połączenie jest wyłączone: uruchomienia przez tę publikację w ogóle nie są przyjmowane, dopóki administrator go ponownie nie włączy.",
                    "assignment_check_off": "Przy wyłączonym przełączniku ponowne przypisanie kursu nie jest wykrywane.",
                    "no_course_binding": "Publikacja nie jest powiązana z kursem — wynik nie trafi do systemu szkoleniowego."
                },
                "dialog": {
                    "connection_label": "Połączenie",
                    "scenario_label": "Scenariusz",
                    "channel_label": "Kanał dostarczania",
                    "channel_hint": "Wbudowany w pakiet i później niezmienialny.",
                    "status_label": "Status",
                    "status_hint": "Publikacji nigdy się nie usuwa — wyłącza się ją. Po tym nowe uruchomienia są odrzucane, a jeszcze niewysłane wyniki zostają anulowane.",
                    "settings_section": "Ustawienia próby",
                    "attempts_label": "Prób na uczestnika",
                    "attempts_unlimited": "Bez ograniczenia",
                    "daily_budget_label": "Uruchomień dziennie na uczestnika",
                    "daily_budget_hint": "Chroni limit: każda rozpoczęta rozmowa go obciąża i nie jest zwracana.",
                    "result_mode_label": "Co trafia do systemu szkoleniowego",
                    "pass_threshold_label": "Próg zaliczenia, 0–100",
                    "result_wait_label": "Czas oczekiwania na ocenę, godziny",
                    "result_wait_hint": "Po jego upływie uruchomienie zgłosi „brak wyniku”.",
                    "launch_limit_label": "Łączny limit uruchomień",
                    "launch_limit_hint": "Zostaw puste, jeśli nie ma limitu.",
                    "assignment_check_label": "Sprawdzaj przypisanie w systemie szkoleniowym",
                    "binding_section": "Powiązanie w systemie szkoleniowym",
                    "external_course_label": "Identyfikator kursu",
                    "external_item_label": "Identyfikator elementu",
                    "expires_label": "Termin publikacji",
                    "expires_hint": "Zostaw puste, jeśli publikacja nie ma terminu."
                },
                "key_dialog": {
                    "title": "Publikacja została utworzona",
                    "warning": "Klucz jest pokazywany jeden raz i tylko tutaj. Nie można go później nigdzie odczytać — skopiuj go teraz i wpisz w ustawieniach pakietu. Jego utrata oznacza konieczność utworzenia nowej publikacji.",
                    "key_label": "Klucz publikacji",
                    "copied": "Skopiowano",
                    "package_hint": "Klucz jest już wewnątrz pakietu, więc nie trzeba nigdzie nic wklejać. Pobierz pakiet i prześlij go do systemu szkoleniowego. Możesz pobrać go ponownie w dowolnym momencie na stronie Publikacje."
                },
                "messages": {
                    "saved": "Publikacja zapisana",
                    "enabled": "Publikacja włączona",
                    "disabled": "Publikacja wyłączona",
                    "download_failed": "Nie udało się pobrać pakietu. Odśwież stronę i spróbuj ponownie."
                }
            },
            "journal": {
                "title": "Dziennik uruchomień",
                "unknown_scenario": "Scenariusz niedostępny",
                "back": "Do publikacji",
                "revoke": "Odwołaj próbę",
                "revoke_confirm": "Odwołać tę próbę? Uczestnik straci dostęp do rozmowy, a niewysłane dostawy zostaną anulowane.",
                "retry_delivery": "Ponów",
                "empty_launches": "Nie ma jeszcze żadnych uruchomień.",
                "empty_events": "Nie ma jeszcze żadnych zdarzeń.",
                "no_deliveries": "Ta próba nie ma dostaw.",
                "not_held_quota_charged": "Nie odbyła się, limit obciążony",
                "relaunches": "powrotów: {value}",
                "last_launch": "ostatnie uruchomienie: {value}",
                "result_deadline": "Czekamy na ocenę do {value}",
                "learner_contacts": "Adres przesłany przez system szkoleniowy: {email}. Uruchomiono z adresu: {ip}",
                "score_passed": "{value} — zaliczone",
                "score_failed": "{value} — niezaliczone",
                "tabs": {
                    "launches": "Próby",
                    "events": "Zdarzenia"
                },
                "headers": {
                    "learner": "Uczestnik",
                    "user": "Konto",
                    "attempt": "Próba",
                    "status": "Status",
                    "game": "Rozmowa",
                    "started_at": "Rozpoczęcie",
                    "actions": " ",
                    "event_type": "Zdarzenie",
                    "refusal": "Powód",
                    "request_proof": "Potwierdzenie żądania",
                    "ip": "Adres",
                    "user_agent": "Klient",
                    "happened_at": "Kiedy"
                },
                "launch_status": {
                    "created": "Link wydany",
                    "started": "W toku",
                    "not_held": "Nie odbyła się",
                    "awaiting_result": "Czekamy na ocenę",
                    "result_ready": "Wynik dostarczony",
                    "evaluation_failed": "Brak oceny",
                    "result_timed_out": "Czas oczekiwania minął",
                    "assignment_changed": "Przypisanie zmienione",
                    "revoked": "Odwołana"
                },
                "delivery": {
                    "version": "Wersja",
                    "status": "Status",
                    "outcome": "Skutek",
                    "result": "Rezultat",
                    "score": "Wynik",
                    "attempts": "Próby",
                    "last_attempt": "Ostatnia próba",
                    "external_state": "Stan w systemie szkoleniowym"
                },
                "delivery_status": {
                    "pending": "W kolejce",
                    "in_progress": "Wysyłanie",
                    "done": "Gotowe",
                    "needs_attention": "Wymaga uwagi"
                },
                "delivery_outcome": {
                    "accepted": "Przyjęto",
                    "confirmed": "Potwierdzono",
                    "rejected_by_external": "Odrzucono",
                    "retry": "Zaplanowano ponowienie",
                    "cancelled": "Anulowano",
                    "assignment_changed": "Przypisanie zmienione"
                },
                "result": {
                    "passed": "Zaliczone",
                    "failed": "Niezaliczone",
                    "not_held": "Nie odbyła się",
                    "no_result": "Brak wyniku"
                },
                "refusal": {
                    "publication_disabled": "Publikacja wyłączona",
                    "publication_draft": "Publikacja to szkic",
                    "publication_expired": "Publikacja wygasła",
                    "feature_disabled": "Zewnętrzne uruchamianie wyłączone",
                    "connection_disabled": "Połączenie wyłączone",
                    "launch_limit_reached": "Osiągnięto limit uruchomień",
                    "daily_budget_exhausted": "Dzienny budżet wyczerpany",
                    "attempts_exhausted": "Próby wyczerpane",
                    "quota_exhausted": "Limit organizacji wyczerpany",
                    "user_limit_reached": "Brak wolnych miejsc",
                    "scenario_unavailable": "Scenariusz niedostępny",
                    "assignment_check_unavailable": "Sprawdzenie przypisania niedostępne",
                    "code_invalid": "Link użyty lub wygasły",
                    "channel_verification_failed": "System szkoleniowy nie potwierdził żądania",
                    "external_system_unavailable": "System szkoleniowy nie odpowiedział na sprawdzenie przypisania",
                    "user_not_found": "Brak konta uczestnika",
                    "user_unavailable": "Konto uczestnika wyłączone",
                    "user_deleted": "Konto uczestnika usunięte",
                    "email_taken_linking_disabled": "Adres należy do innego konta",
                    "service_role_not_allowed": "Konto usługowe nie może ćwiczyć",
                    "unverified_request": "Żądanie niepotwierdzone"
                },
                "event_type": {
                    "launch_refused": "Uruchomienie odrzucone",
                    "exchange_refused": "Link odrzucony",
                    "exchange_succeeded": "Link użyty"
                },
                "request_proof": {
                    "unverified": "Niepotwierdzony",
                    "assignment_verified": "Przypisanie potwierdzone"
                },
                "messages": {
                    "retry_queued": "Ponowienie dodane do kolejki",
                    "revoked": "Próba odwołana"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Szkolenie",
            "interview": "Rozmowa"
        },
        "load": {
            "loading": "Ładowanie sesji…",
            "failed": "Nie udało się załadować sesji. Sprawdź połączenie i spróbuj ponownie.",
            "scenarioFailed": "Scenariusz nie załadował się",
            "scenarioRetry": "Spróbuj ponownie"
        },
        "leave": {
            "confirm": "Rozmowa wciąż trwa. Opuszczenie strony jej nie zakończy, a czas będzie nadal biegł. Opuścić stronę?",
            "confirmEnd": "Rozmowa wciąż trwa. Jeśli wyjdziesz, zakończy się i zostanie oceniona na podstawie tego, co udało się omówić. Wyjść?"
        },
        "elsewhere": {
            "interviewTitle": "Rozmowa jest otwarta w innej karcie",
            "interviewText": "Rozmowa trwa w innej karcie lub na innym urządzeniu. Kontynuuj ją tam — tę kartę możesz zamknąć.",
            "conversationTitle": "Rozmowa jest otwarta w innej karcie",
            "conversationText": "Rozmowa trwa w innej karcie lub na innym urządzeniu. Kontynuuj ją tam — tę kartę możesz zamknąć."
        },
        "prep": {
            "header": {
                "backToSessions": "Do sesji",
                "themeToggleAriaLabel": "Przełącz motyw"
            },
            "scenario": {
                "sectionLabel": "Scenariusz",
                "competenceLabel": "Oceniana kompetencja",
                "gameNumber": "Sesja #{number}",
                "duration": "{minutes} min",
                "readFull": "Czytaj całość",
                "generalLabel": "Informacje ogólne",
                "playerLabel": "Informacje dla Ciebie"
            },
            "selfCamera": {
                "previewLabel": "Podgląd Twojej kamery",
                "off": "Kamera wyłączona"
            },
            "notes": {
                "empty": "Puste"
            },
            "start": {
                "button": "Rozpocznij sesję",
                "interviewButton": "Rozpocznij rozmowę",
                "resumeButton": "Wróć do rozmowy",
                "resumeHint": "Rozmowa już trwa — czas nadal biegnie."
            }
        },
        "equipment": {
            "status": {
                "checking": "Sprawdzanie sprzętu",
                "waiting": "Oczekiwanie na zgodę",
                "denied": "Dostęp odmówiony",
                "busy": "Urządzenie zajęte",
                "noCamera": "Brak kamery",
                "missing": "Brak mikrofonu",
                "dismissed": "Brak zgody",
                "ready": "Sprzęt gotowy"
            },
            "checking": {
                "title": "Trwa sprawdzanie mikrofonu i kamery…"
            },
            "waiting": {
                "title": "Zezwól na dostęp do mikrofonu",
                "cameraTitle": "Zezwól na dostęp do kamery",
                "description": "Okno przeglądarki z prośbą o zgodę jest już otwarte. Bez mikrofonu rozmowa się nie rozpocznie."
            },
            "denied": {
                "title": "Przeglądarka blokuje dostęp do mikrofonu",
                "cameraTitle": "Przeglądarka blokuje dostęp do kamery",
                "description": "Przeglądarka zapamiętała blokadę. Zezwól na dostęp do mikrofonu w ustawieniach witryny i odśwież stronę.",
                "cameraDescription": "Przeglądarka zapamiętała blokadę. Zezwól na dostęp do kamery w ustawieniach witryny i odśwież stronę.",
                "showInstructions": "Pokaż jak",
                "hideInstructions": "Ukryj",
                "chromeEdge": {
                    "browser": "Chrome i Edge",
                    "text": "Kliknij ikonę kłódki po lewej stronie paska adresu, otwórz „Ustawienia witryny”, zezwól na „Mikrofon” i odśwież stronę."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Otwórz menu Safari → „Ustawienia dla tej witryny”, zezwól na „Mikrofon” i odśwież stronę."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Kliknij ikonę mikrofonu na pasku adresu, usuń blokadę dla tej witryny i odśwież stronę."
                },
                "system": {
                    "title": "System blokuje przeglądarce dostęp do mikrofonu",
                    "cameraTitle": "System blokuje przeglądarce dostęp do kamery",
                    "macos": "macOS: Ustawienia systemowe → Prywatność i bezpieczeństwo → Mikrofon (lub Kamera) → włącz przeglądarkę i uruchom ją ponownie.",
                    "windows": "Windows: Ustawienia → Prywatność i zabezpieczenia → Mikrofon (lub Kamera) → zezwól na dostęp aplikacjom i przeglądarce, a następnie kliknij „Spróbuj ponownie”."
                }
            },
            "busy": {
                "title": "Mikrofon jest zajęty przez inną aplikację",
                "cameraTitle": "Kamera jest zajęta przez inną aplikację",
                "description": "Zwykle to połączenie działające w tle. Zamknij je i kliknij „Spróbuj ponownie”.",
                "retry": "Spróbuj ponownie"
            },
            "noCamera": {
                "title": "Brak kamery",
                "description": "Inni Cię usłyszą, ale nie zobaczą.",
                "requiredByScenario": "Ta rozmowa wymaga kamery. Podłącz kamerę, aby kontynuować."
            },
            "missing": {
                "title": "Nie znaleziono mikrofonu",
                "description": "Podłącz mikrofon i kliknij „Spróbuj ponownie”. Bez mikrofonu rozmowa się nie rozpocznie."
            },
            "dismissed": {
                "title": "Nie udzielono dostępu do mikrofonu",
                "cameraTitle": "Nie udzielono dostępu do kamery",
                "description": "Okno przeglądarki zostało zamknięte bez odpowiedzi. Kliknij „Spróbuj ponownie” i zezwól na dostęp."
            },
            "ready": {
                "title": "Sprzęt gotowy"
            },
            "micLabel": "Mikrofon",
            "cameraLabel": "Kamera",
            "chooseMic": "Wybierz mikrofon",
            "chooseCamera": "Wybierz kamerę",
            "micLevelHint": "Powiedz coś",
            "speakerValue": "Głośnik: {name}",
            "configure": "Skonfiguruj",
            "dialog": {
                "title": "Sprzęt",
                "lockedDuringConversation": "Urządzeń nie można zmieniać podczas rozmowy.",
                "micSelectLabel": "Mikrofon",
                "cameraSelectLabel": "Kamera",
                "speakerSelectLabel": "Głośnik",
                "noCameraOption": "Bez kamery",
                "record": "Nagraj 3 sekundy",
                "recording": "Nagrywanie…",
                "recordFailed": "Nie udało się nagrać. Spróbuj ponownie.",
                "listen": "Odtwórz",
                "playing": "Odtwarzanie…",
                "done": "Gotowe",
                "closeAriaLabel": "Zamknij okno dialogowe"
            },
            "unnamed": {
                "microphone": "Mikrofon {number}",
                "camera": "Kamera {number}",
                "speaker": "Głośnik {number}"
            },
            "cameraWarmup": {
                "preview": "Kamera się włącza",
                "title": "Mikrofon gotowy",
                "description": "Kamera dołączy — zwykle po sekundzie lub dwóch.",
                "slowHint": "Kamera się nie włącza? Wybierz inną, klikając „Skonfiguruj”."
            }
        },
        "recording": {
            "videoAndAudio": "Rozmowa i wideo są nagrywane.",
            "audioOnly": "Rozmowa jest nagrywana.",
            "accessSelfAndEvaluators": "Nagranie jest dostępne dla Ciebie i dla osób oceniających Twoją pracę.",
            "accessEvaluators": "Nagranie jest dostępne dla osób oceniających Twoją pracę."
        },
        "scenario": {
            "video": "Wideo od autora scenariusza"
        },
        "notes": {
            "title": "Notatki do sesji",
            "placeholder": "Co chcesz przećwiczyć, przygotowane sformułowania",
            "saving": "Zapisywanie…",
            "saved": "Zapisano",
            "saveError": "Nie udało się zapisać",
            "visibility": "Notatki są widoczne dla Ciebie i dla osób oceniających sesję.",
            "unsupported": "Te notatki zawierają elementy, których nie można tu edytować. Pozostają bez zmian."
        },
        "stage": {
            "agentState": {
                "speaking": "Mówi",
                "listening": "Słucha",
                "thinking": "Myśli"
            },
            "micOffWarning": "Mikrofon wyłączony — rozmówca Cię nie słyszy",
            "micOnAriaLabel": "Wyłącz mikrofon",
            "micOffAriaLabel": "Włącz mikrofon",
            "micOff": "Mikrofon wyłączony",
            "micOnAnnouncement": "Mikrofon włączony",
            "captionsLabel": "Napisy",
            "captionsOnAriaLabel": "Ukryj napisy",
            "captionsOffAriaLabel": "Pokaż napisy",
            "talkBalance": {
                "title": "Bilans rozmowy",
                "you": "Ty",
                "interlocutor": "Rozmówca"
            },
            "connectionQuality": {
                "excellent": "Doskonałe połączenie",
                "good": "Dobre połączenie",
                "poor": "Słabe połączenie",
                "unknown": "Jakość połączenia nieznana"
            },
            "selfCameraLabel": "Ty",
            "timeWarning": {
                "lastMinute": "Została minuta — czas kończyć",
                "finalSeconds": "15 sekund — dokończ myśl"
            },
            "timeUp": {
                "title": "Czas minął",
                "text": "Rozmowa zakończy się automatycznie, nie można jej przedłużyć.",
                "closing": "Kończenie rozmowy…"
            },
            "voiceOnly": "Tryb głosowy — ten scenariusz nie ma wideo",
            "interlocutorConnecting": {
                "title": "Rozmówca się łączy",
                "hint": "Zwykle 2–4 sekundy"
            },
            "layout": {
                "label": "Obok siebie",
                "sideTitle": "Ułóż obok siebie",
                "focusTitle": "Powiększ rozmówcę"
            }
        },
        "panels": {
            "scenario": "Scenariusz",
            "transcript": "Transkrypcja",
            "transcriptEmpty": "Tutaj pojawią się zakończone wypowiedzi.",
            "notes": "Notatki",
            "characterMemoryTab": "Co pamięta postać",
            "openAriaLabel": "Otwórz panel „{panel}”",
            "closeAriaLabel": "Zamknij panel „{panel}”"
        },
        "sound": {
            "label": "Dźwięk",
            "volumeLabel": "Głośność",
            "speakerLabel": "Głośnik"
        },
        "end": {
            "button": "Zakończ",
            "confirmTitle": "Zakończyć rozmowę?",
            "elapsed": "Upłynęło {elapsed} z {total}.",
            "partialEvaluationNotice": "Rozmowa zostanie oceniona na podstawie tego, co udało się omówić.",
            "continue": "Kontynuuj",
            "notSent": "Rozmowa zakończy się z upływem czasu: serwer nie odpowiedział na prośbę o zakończenie."
        },
        "wait": {
            "title": "Przygotowujemy rozmowę",
            "hint": "Zwykle trwa to 1–3 minuty. Nie zamykaj strony — zaczniemy automatycznie.",
            "nextTry": "Następna próba za {time}",
            "trying": "Próbujemy zacząć…",
            "retrying": "Jeszcze się nie udało. Spróbujemy ponownie za {time}",
            "cancel": "Anuluj",
            "failed": {
                "title": "Nie udało się rozpocząć rozmowy",
                "text": "Teraz nie ma wolnych miejsc. Ustawienia mikrofonu i kamery zostały zapisane — spróbuj ponownie za kilka minut.",
                "retry": "Spróbuj ponownie"
            }
        },
        "connection": {
            "reconnecting": "Połączenie utracone, ponowne łączenie…",
            "restored": "Połączenie przywrócone",
            "failed": "Nie udało się przywrócić połączenia",
            "retry": "Spróbuj ponownie"
        },
        "hotkeys": {
            "title": "Skróty klawiszowe",
            "showHintAriaLabel": "Pokaż skróty klawiszowe",
            "micToggle": "Włącz/wyłącz mikrofon",
            "scenarioPanel": "Scenariusz: otwórz i zamknij panel",
            "transcriptPanel": "Transkrypcja",
            "notesPanel": "Notatki",
            "captionsToggle": "Włącz/wyłącz napisy",
            "closeTopLayer": "Zamknij panel, popover lub okno dialogowe",
            "endConfirm": "Zakończ — otwiera potwierdzenie",
            "showHint": "Pokaż tę podpowiedź"
        },
        "intro": {
            "candidate": {
                "greeting": "Dzień dobry, {name}!",
                "leadWithVacancy": "{organization} zaprasza na rozmowę kwalifikacyjną z wirtualnym rozmówcą na stanowisko „{vacancy}”.",
                "duration": "Rozmowa zajmie około {minutes} min.",
                "requirementsTitle": "Co będzie potrzebne",
                "requirementMic": "Sprawny mikrofon, najlepiej słuchawki z mikrofonem",
                "requirementCameraRequired": "Włączona kamera: jest wymagana podczas tej rozmowy",
                "requirementCameraOptional": "Kamera nie jest wymagana, ale z nią rozmowa przebiega bardziej naturalnie",
                "requirementBrowser": "Komputer z aktualną wersją przeglądarki Chrome, Edge lub Safari",
                "requirementNetwork": "Stabilne połączenie internetowe i ciche miejsce bez zakłóceń",
                "consentTextLabel": "Treść zgody",
                "consentAccept": "Zapoznałem/-am się z treścią i wyrażam zgodę na przetwarzanie moich danych osobowych",
                "next": "Dalej"
            },
            "launch": {
                "title": "Rozmowa treningowa",
                "lead": "Zaraz porozmawiasz z wirtualnym rozmówcą. Rozmowa jest nagrywana i oceniana, a wynik trafi do Twojego systemu szkoleniowego.",
                "requirementsTitle": "Czego będziesz potrzebować",
                "requirementMic": "Sprawnego mikrofonu, najlepiej zestawu słuchawkowego",
                "requirementCamera": "Kamera nie jest obowiązkowa, ale z nią rozmowa wypada bardziej naturalnie",
                "requirementBrowser": "Komputera z aktualną wersją Chrome, Edge lub Safari",
                "requirementNetwork": "Stabilnego łącza i cichego miejsca, w którym nikt Ci nie przeszkodzi",
                "start": "Rozpocznij"
            }
        },
        "finished": {
            "candidate": {
                "title": "Dziękujemy!",
                "text": "Rozmowa dobiegła końca. Wynik trafi do rekrutera, który się odezwie. Tę stronę można już zamknąć."
            },
            "launch": {
                "title": "Dziękujemy!",
                "text": "Rozmowa zakończona. Wynik pojawi się w Twoim systemie szkoleniowym, gdy tylko zostanie oceniony. Tę stronę możesz już zamknąć."
            }
        },
        "closeDialogAriaLabel": "Zamknij okno dialogowe"
    },
    "loopAvatars": {
        "title": "Awatary zapętlone",
        "upload": "Prześlij awatar",
        "newVersion": "Nowa wersja",
        "newVersionHint": "„{name}”, bieżąca wersja {version}. Nowy pakiet zastąpi nagrania we wszystkich profilach z tym awatarem.",
        "edit": "Edytuj awatar",
        "delete": "Usuń awatar",
        "empty": "Brak awatarów",
        "headers": {
            "poster": "Plakat",
            "name": "Nazwa",
            "gender": "Płeć",
            "emotion": "Emocja",
            "visibility": "Widoczność",
            "version": "Wersja",
            "profiles": "Profile"
        },
        "gender": {
            "male": "Mężczyzna",
            "female": "Kobieta"
        },
        "emotion": {
            "calm": "Spokojny",
            "friendly": "Przyjazny",
            "strict": "Surowy"
        },
        "visibility": {
            "all": "Wszystkie organizacje"
        },
        "fields": {
            "package": "Pakiet awatara (.zip)"
        },
        "packageHint": "ZIP do 100 MB z plikami manifest.json, listen.mp4, talk.mp4, transitions.json i poster.jpg",
        "validation": {
            "packageTooLarge": "Pakiet nie może przekraczać 100 MB"
        },
        "errors": {
            "requestFailed": "Nie udało się wykonać żądania. Spróbuj ponownie."
        },
        "confirmDetach": "Profile do odłączenia: {count}. Przełączą się na zdjęcie. Zapisać?",
        "confirmDelete": "Usunąć awatar „{name}”?",
        "confirmDeleteWithProfiles": "Awatar „{name}” jest używany w profilach: {count}. Przełączą się na zdjęcie. Usunąć?"
    },
    "ttsVoices": {
        "title": "Głosy TTS",
        "create": "Dodaj głos",
        "edit": "Edytuj głos",
        "delete": "Usuń głos",
        "replaceSample": "Zastąp próbkę",
        "replaceSampleHint": "„{name}”, bieżąca wersja próbki {version}. Nowa próbka będzie brzmieć we wszystkich profilach z tym głosem.",
        "empty": "Brak głosów",
        "play": "Odsłuchaj próbkę",
        "stop": "Zatrzymaj",
        "headers": {
            "name": "Nazwa",
            "provider": "Dostawca",
            "externalId": "ID głosu",
            "gender": "Płeć",
            "languages": "Języki",
            "visibility": "Widoczność",
            "sample": "Próbka",
            "profiles": "Profile"
        },
        "gender": {
            "male": "Mężczyzna",
            "female": "Kobieta"
        },
        "visibility": {
            "all": "Wszystkie organizacje"
        },
        "fields": {
            "sample": "Próbka głosu",
            "speed": "Tempo mowy"
        },
        "sampleHint": "MP3, MP4 lub M4A do 5 MB",
        "sampleOptionalHint": "Opcjonalnie — próbka zostanie wygenerowana głosem na podstawie jego ID. MP3, MP4 lub M4A do 5 MB",
        "synthesizeSample": "Wygeneruj ponownie",
        "speedChangedHint": "Aby usłyszeć nowe tempo, wygeneruj ponownie próbkę głosu.",
        "speedSamplePromptTitle": "Zmieniono tempo",
        "speedSamplePrompt": "Próbka nadal brzmi w poprzednim tempie. Wygenerować ją ponownie? Obecna próbka zostanie zastąpiona.",
        "saveAndSynthesize": "Zapisz i wygeneruj",
        "saveOnly": "Tylko zapisz",
        "validation": {
            "sampleTooLarge": "Próbka nie może przekraczać 5 MB"
        },
        "errors": {
            "requestFailed": "Nie udało się wykonać żądania. Spróbuj ponownie.",
            "sampleUnavailable": "Nie udało się odtworzyć próbki"
        },
        "confirmDetach": "Profile do odłączenia: {count}. Przełączą się na głos konektora. Zapisać?",
        "confirmDelete": "Usunąć głos „{name}”?",
        "confirmDeleteWithProfiles": "Głos „{name}” jest używany w profilach: {count}. Przełączą się na głos konektora. Usunąć?",
        "picker": {
            "none": "Głos domyślny",
            "empty": "W katalogu nie ma głosów tej płci",
            "loadError": "Nie udało się załadować głosów",
            "playSample": "Odsłuchaj próbkę: {name}",
            "stopSample": "Zatrzymaj próbkę: {name}",
            "sampleUnavailable": "Próbka niedostępna"
        }
    },
    "realtimeAvatars": {
        "title": "Awatary Live",
        "create": "Dodaj awatar",
        "edit": "Edytuj awatar",
        "delete": "Usuń awatar",
        "preview": "Obejrzyj podgląd",
        "empty": "Brak awatarów",
        "headers": {
            "poster": "Plakat",
            "name": "Nazwa",
            "provider": "Dostawca",
            "externalId": "ID awatara",
            "gender": "Płeć",
            "visibility": "Widoczność",
            "profiles": "Profile",
            "models": "Modele Anam"
        },
        "gender": {
            "male": "Mężczyzna",
            "female": "Kobieta"
        },
        "visibility": {
            "all": "Wszystkie organizacje"
        },
        "nameHint": "Opcjonalnie — zostanie użyta nazwa z Anam",
        "externalIdHint": "Po zmianie ID plakat i podgląd zostaną ponownie pobrane z Anam",
        "errors": {
            "requestFailed": "Żądanie nie powiodło się. Spróbuj ponownie.",
            "previewUnavailable": "Nie udało się odtworzyć podglądu"
        },
        "confirmDetach": "Profile do odłączenia: {count}. Przełączą się na zdjęcie. Zapisać?",
        "confirmDelete": "Usunąć awatar „{name}”?",
        "confirmDeleteWithProfiles": "Awatar „{name}” jest używany w profilach: {count}. Przełączą się na zdjęcie. Usunąć?",
        "picker": {
            "label": "Awatary Live",
            "empty": "Brak awatarów Live dla tego profilu",
            "emptyFiltered": "Brak awatarów Live tej płci",
            "loadError": "Nie udało się załadować awatarów Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Wygląd",
        "photo": "Własne zdjęcie",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Maskotka",
        "filterGender": "Płeć",
        "filterEmotion": "Emocja",
        "avatarsLabel": "Awatary",
        "avatarRequired": "Wybierz awatar",
        "liveRequired": "Wybierz awatar Live",
        "livePlaceholder": "Tutaj pojawi się Twój awatar Live",
        "empty": "Brak awatarów dla tego profilu",
        "emptyFiltered": "Żaden awatar nie pasuje do filtrów",
        "loadError": "Nie udało się załadować awatarów",
        "playPreview": "Odtwórz podgląd: {name}",
        "pausePreview": "Wstrzymaj podgląd: {name}"
    },
    "emailStopList": {
        "title": "Lista blokad e-mail",
        "description": "Wiadomości na te adresy i domeny nie są wysyłane. Wpis domeny obejmuje wszystkie adresy tej domeny, ale nie jej subdomeny.",
        "searchPlaceholder": "Szukaj według adresu lub domeny",
        "allReasons": "Wszystkie powody",
        "add": "Dodaj",
        "addTitle": "Zablokuj adres lub domenę",
        "empty": "Lista blokad jest pusta",
        "editNote": "Edytuj notatkę",
        "headers": {
            "type": "Typ",
            "value": "Adres lub domena",
            "reason": "Powód",
            "providerReply": "Odpowiedź serwisu pocztowego",
            "note": "Notatka",
            "author": "Dodane przez",
            "createdAt": "Data dodania",
            "blockedCount": "Zatrzymane wiadomości",
            "lastBlockedAt": "Ostatnio zatrzymano"
        },
        "type": {
            "address": "Adres",
            "domain": "Domena"
        },
        "reason": {
            "manual": "Dodano ręcznie",
            "providerRejected": "Odrzucone przez serwis pocztowy"
        },
        "author": {
            "system": "System"
        },
        "fields": {
            "value": "Adres lub domena",
            "valueHint": "Podaj cały adres lub samą domenę. Domena blokuje wszystkie swoje adresy, ale nie subdomeny.",
            "note": "Notatka"
        },
        "errors": {
            "requestFailed": "Coś poszło nie tak. Spróbuj ponownie."
        },
        "unblock": {
            "action": "Odblokuj",
            "confirm": "Odblokować {value}?",
            "resultTitle": "Wynik odblokowania",
            "result": {
                "removedEverywhere": "Odblokowano. Serwis pocztowy nie ma tego adresu na swojej liście blokad, więc wiadomości będą znów wysyłane.",
                "removedLocally": "Domena odblokowana. Adresy tej domeny, które mają własny wpis, pozostają zablokowane.",
                "providerNotConfigured": "Usunięto tylko wpis platformy: połączenie z serwisem pocztowym nie jest skonfigurowane, więc jego lista blokad nie została sprawdzona.",
                "providerUnavailable": "Serwis pocztowy jest niedostępny, spróbuj ponownie później. Adres nadal jest zablokowany.",
                "stillListedAtProvider": "Adres jest na liście blokad serwisu pocztowego. Usuń go w panelu serwisu i kliknij „Odblokuj ponownie”. Jeśli adresu nie ma w panelu, znajduje się on na globalnej liście blokad serwisu i nie można go stamtąd usunąć."
            },
            "openPanel": "Otwórz panel serwisu pocztowego",
            "panelPath": "Gdzie usunąć: panel serwisu pocztowego → Products → Email Service → Twój zasób → karta Stop Lists.",
            "retry": "Odblokuj ponownie"
        },
        "suggestions": {
            "text": "W domenie {domain} zablokowano adresów: {count}. Zablokować całą domenę?",
            "block": "Zablokuj domenę",
            "confirm": "Zablokować domenę {domain}? Wiadomości na wszystkie jej adresy przestaną być wysyłane. Subdomeny nie zostaną objęte, wpisy pojedynczych adresów pozostaną."
        },
        "check": {
            "title": "Sprawdź adres",
            "hint": "Pokaże, czy wiadomości na ten adres blokuje platforma lub serwis pocztowy",
            "placeholder": "Adres e-mail",
            "submit": "Sprawdź",
            "resultFor": "Wynik dla {email}",
            "platform": "Lista blokad platformy",
            "platformListed": "Tak — wpis „{value}”",
            "provider": "Lista blokad serwisu pocztowego",
            "listed": "Tak",
            "notListed": "Nie",
            "providerReasons": "Powody podane przez serwis pocztowy:",
            "providerNotConfigured": "Połączenie z serwisem pocztowym nie jest skonfigurowane",
            "providerUnavailable": "Serwis pocztowy jest niedostępny, spróbuj ponownie później"
        }
    }
}
